const config = require("../config.js");
const UTILS = require("./utils.js");
const THREE = require("three");
THREE.BufferGeometryUtils = require("./BufferGeometryUtils.js")(THREE);
THREE.RectAreaLightUniformsLib = require("./RectAreaLightUniformsLib.js").RectAreaLightUniformsLib;
THREE.SkeletonUtils = require("./SkeletonUtils.js");
require("../132.js")(THREE);
require("../133.js")(THREE);
THREE.OBJLoader = require("./OBJLoader.js").OBJLoader;
THREE.FBXLoader = require("./FBXLoader.js").FBXLoader;
THREE.GLTFLoader = require("./GLTFLoader.js").GLTFLoader;
THREE.MeshoptDecoder = require("./MeshoptDecoder.js").MeshoptDecoder;
THREE.ImageUtils.crossOrigin = "";
var SkyDome = require("./SkyDome.js");
var Ocean = require("./Ocean.js");
var shaders = require("../data/shaders.js");
var prefabs = new (require("../data/prefabs.js"))();
var v6087 = false;
if (!v6087) {
  WebGLRenderingContext.prototype.getProgramInfoLog = () => "";
  WebGLRenderingContext.prototype.getShaderInfoLog = () => "";
  if (typeof WebGL2RenderingContext != "undefined") {
    WebGL2RenderingContext.prototype.getProgramInfoLog = () => "";
    WebGL2RenderingContext.prototype.getShaderInfoLog = () => "";
  }
} else {
  var debugStats = document.getElementById("debugStats");
  if (debugStats) {
    debugStats.style.display = "block";
  }
}
var v6089;
var v6090;
var v6091 = new THREE.Vector3();
module.exports = function (p7238, p7239, p7240, p7241, p7242) {
  function f1115(p7243, p7244) {
    if (p7244.rAnim) {
      var vO161 = {
        mesh: p7243,
        tim: p7244.rAnim,
        type: p7244.rAnimT,
        mlt: p7244.rAnimM,
        axis: (p7244.rAnimA || "y")[p7244.rAnimT ? "toLowerCase" : "toUpperCase"]()
      };
      if (vO161.type) {
        vO161.orgP = p7243.position[vO161.axis];
      }
      vThis47.movMeshes.push(vO161);
    }
  }
  function f1116(p7245, p7246) {
    let v6092 = false;
    for (let vLN0966 = 0; vLN0966 < vA332.length; vLN0966++) {
      if (p7245[vA332[vLN0966]] && p7245[vA332[vLN0966]].encoding != p7246) {
        p7245[vA332[vLN0966]].encoding = p7246;
        v6092 = true;
      }
    }
    if (v6092) {
      p7245.needsUpdate = true;
    }
  }
  function f1117(p7247, p7248, p7249, p7250) {
    p7247.morphMeshes = [];
    p7247.updateMorphKey = function (p7251, p7252) {
      if (this.morphMeshes.length) {
        p7252 = parseFloat(p7252);
        if (!UTILS.isNumber(p7252)) {
          p7252 = 0;
        }
        p7252 = UTILS.limitMM(p7252, 0, 1);
        for (let vLN0967 = 0; vLN0967 < this.morphMeshes.length; vLN0967++) {
          var v6093 = this.morphMeshes[vLN0967].morphTargetDictionary[p7251];
          if (v6093 != null && this.morphMeshes[vLN0967].morphTargetInfluences[v6093] != null) {
            this.morphMeshes[vLN0967].morphTargetInfluences[v6093] = p7252;
          }
        }
      }
    };
    p7250.traverse(p7253 => {
      if (p7253.isMesh) {
        if (p7253.morphTargetInfluences) {
          p7253.updateMorphTargets();
          var v6094 = Object.keys(p7253.morphTargetDictionary);
          if (v6094.length) {
            p7247.morphMeshes.push(p7253);
          }
        }
        vThis47.traverseMats(p7253, function (p7254) {
          if (p7248 && p7248.texEncode) {
            f1116(p7254, THREE[config.encodingTypes[p7248.texEncode || 0].value]);
          }
          if (p7248 && p7248.noFog) {
            p7254.fog = false;
          }
          if (p7248.color && p7248.color != "#ffffff") {
            p7254.color = new THREE.Color(vThis47.GEOS.getColor(p7248.color));
          }
          if (UTILS.isNumber(p7248.opacity) && p7248.opacity != 1) {
            p7254.opacity = p7248.opacity;
            p7254.transparent = p7248.opacity != 1;
          }
          if (p7248.fileExt == "gltf" || p7248.fileExt == "glb") {
            p7254.depthWrite = !p7254.transparent;
          }
          if (p7248.pulsT) {
            vThis47.pulsMats.push({
              mat: p7254,
              pul: p7248.pulsT,
              minGlo: p7248.minGlo
            });
          }
          if (p7248.rgb) {
            vThis47.rgbMats.push({
              mat: p7254,
              mlt: p7248.rgbS || 0.3,
              type: p7248.rgbT || 0,
              dlt: 0
            });
          }
          if (p7248.env) {
            p7248.mapping = 3;
            if (p7248.sameEnv) {
              p7254.envMap = p7254.map.clone();
              p7254.envMap.mapping = THREE[config.mappingTypes[p7248.mapping || 0]];
              p7254.envMap.needsUpdate = true;
            } else {
              vThis47.loadTexture(p7254, (p7248.texSrc || p7248.src) + (p7248.sameEnv ? "" : "_env"), p7248, "envMap");
            }
            p7254.envMapIntensity = p7248.env || 3;
          }
          p7254.needsUpdate = true;
        });
        p7253.receiveShadow = !p7248.noShadow;
        p7253.castShadow = p7248.shadows;
        if (p7248.forceRender) {
          p7253.frustumCulled = false;
          p7253.renderOrder = Infinity;
          p7253.needsUpdate = true;
        }
      }
    });
    p7247.nodes = p7249.nodes || [];
    if (p7249.animations && p7249.animations.length) {
      p7247.clips = p7249.animations || [];
      p7247.mixer = new THREE.AnimationMixer(p7250);
      p7247.mixer.timeScale = p7248.animS || 1;
      vA326.push({
        uuid: p7247.uuid,
        mixer: p7247.mixer
      });
      p7247.anims = {};
      for (var vLN0968 = 0; vLN0968 < p7247.clips.length; ++vLN0968) {
        p7247.anims[p7247.clips[vLN0968].name] = p7247.mixer.clipAction(p7247.clips[vLN0968]);
      }
      p7247.playClip = function (p7255, p7256 = 0, p7257) {
        p7257 = p7257 || 0.2;
        const v6095 = this.anims[p7255];
        if (v6095) {
          if (p7256) {
            if (this.currAnim && this.currAnim != v6095) {
              this.currAnim.fadeOut(p7257);
            }
            v6095.reset();
            v6095.clampWhenFinished = true;
            if (p7256) {
              v6095.setLoop(THREE.LoopOnce, p7256);
            }
            v6095.setEffectiveTimeScale(1).setEffectiveWeight(1).play();
            this.currAnim = v6095;
          } else if ((this.mainAnim != v6095 || isFinite(this.currAnim.repetitions)) && (!this.currAnim || !isFinite(this.currAnim.repetitions) || !this.currAnim.isRunning())) {
            if (this.currAnim) {
              this.currAnim.fadeOut(p7257);
            }
            v6095.reset().setEffectiveTimeScale(1).setEffectiveWeight(1).play();
            this.mainAnim = v6095;
            this.currAnim = v6095;
          }
        }
      };
      p7247.playAllClips = function (p7258 = 0) {
        for (var v6096 in this.anims) {
          if (this.anims.hasOwnProperty(v6096)) {
            this.anims[v6096].reset();
            if (p7258) {
              this.anims[v6096].setLoop(THREE.LoopRepeat, p7258);
            }
            this.anims[v6096].play();
          }
        }
      };
      p7247.stopAllClips = function () {
        this.mainAnim = null;
        this.currAnim = null;
        for (var v6097 in this.anims) {
          if (this.anims.hasOwnProperty(v6097)) {
            this.anims[v6097].stop();
          }
        }
      };
      if (!p7248.inspectAnim) {
        if (p7248.startAnim) {
          p7247.playClip(p7248.startAnim);
        } else {
          p7247.playAllClips();
        }
      }
    }
    if (p7248.forceRender) {
      p7250.frustumCulled = false;
      p7250.renderOrder = Infinity;
    }
    p7247.add(p7250);
    f1115(p7247, p7248);
    if (p7248.setLayer != null) {
      p7247.traverse(function (p7259) {
        p7259.layers.set(p7248.setLayer);
      });
    }
  }
  this.THREE = THREE;
  this.isMobile = p7242;
  this.ShaderMesh = require("./ShaderMesh.js")(THREE, this);
  this.shaderRendering = p7241;
  this.ShaderMesh.enabled = !!p7241;
  this.GEOS = require("./geos.js");
  var v6098 = new THREE.OBJLoader();
  var v6099 = new THREE.GLTFLoader();
  v6099.setMeshoptDecoder(THREE.MeshoptDecoder);
  var v6100 = new THREE.FBXLoader();
  this.cubeGeo = new THREE.BoxGeometry(1, 1, 1);
  this.getCubeMesh = () => new THREE.Mesh(this.cubeGeo);
  var v6101 = new THREE.PlaneGeometry(1, 1);
  var v6102 = new THREE.TextureLoader();
  v6102.crossOrigin = "";
  var vA319 = [new THREE.MeshBasicMaterial({
    color: 65535,
    side: THREE.BackSide
  }), new THREE.MeshBasicMaterial({
    color: 13938487,
    side: THREE.BackSide
  }), new THREE.MeshBasicMaterial({
    color: 11299257,
    side: THREE.BackSide
  })];
  this.invisMat = new THREE.MeshBasicMaterial();
  this.invisMat.visible = false;
  var v6103;
  var v6104;
  var vO162 = {};
  var vO163 = {};
  var vO164 = {};
  var vO165 = {};
  this.movTextures = [];
  this.rotTextures = [];
  this.movMeshes = [];
  this.rendDisObjs = [];
  this.rendDisCnt = 0;
  this.pulsMats = [];
  this.rgbMats = [];
  this.liquids = [];
  this.frameMats = [];
  this.pulsVal = 0;
  this.liquidVal = 0;
  this.frustumSize = 50;
  this.newliquid = true;
  this.targetVector = new THREE.Vector3();
  this.mirroredMatrix = new THREE.Matrix4().makeScale(-1, 1, 1);
  var vThis47 = this;
  var vO166 = {};
  this.tmpMouse = new THREE.Vector2();
  this.tmpMouse2 = new THREE.Vector2();
  this.frustum = new THREE.Frustum();
  const v6105 = this.frustum.containsPoint;
  this.frustum.containPoint = v6105;
  this.frustum.containsPoint = new Proxy(this.frustum.containsPoint, {
    apply: function () {
      return false;
    }
  });
  var v6106 = new THREE.Matrix4();
  var v6107 = new THREE.PerspectiveCamera(0, window.innerWidth / window.innerHeight, 0.1, 6000);
  var v6108 = new THREE.OrthographicCamera(-vThis47.frustumSize * 1.7 / 2, vThis47.frustumSize * 1.7 / 2, vThis47.frustumSize / 2, -vThis47.frustumSize / 2, 0.1, 2000);
  this.camera = v6107;
  Object.freeze(this.camera.scale);
  /** @type {THREE.Scene} */
  this.scene = new THREE.Scene();
  /** @type {THREE.Scene} */
  this.backgroundScene = new THREE.Scene();
  this.fpsCamera = new THREE.PerspectiveCamera(config.fov, window.innerWidth / window.innerHeight, 0.1, 200);
  Object.freeze(this.fpsCamera.scale);
  Object.freeze(this.fpsCamera.quaternion);
  Object.freeze(this.fpsCamera.position);
  Object.freeze(this.fpsCamera.rotation);
  this.fpsCamera.layers.set(1);
  this.camera.add(this.fpsCamera);
  var v6109 = new THREE.Vector3();
  this.getTmpVector = function (p7260, p7261, p7262) {
    v6109.set(p7260, p7261, p7262);
    return v6109;
  };
  this.vmSetts = 0;
  this.gpSetts = 0;
  this.weaponOffX = [1];
  this.weaponOffY = [1];
  this.weaponOffZ = [1];
  this.weapReloadY = [1];
  this.weapSwapY = [1];
  this.weaponADSOffY = [1];
  this.weaponLean = [1];
  this.weaponBob = [1];
  this.weaponRot = [0];
  this.liquidUpd = 0;
  this.liquidFreq = 50;
  this.hideADS = [0];
  this.showHands = true;
  this.softShad = false;
  this.highResShad = false;
  this.ambientShading = true;
  this.mapDet = false;
  this.aimAnim = [true];
  this.renderDst = 0;
  this.reticleIndex = 0;
  this.lowSpec = false;
  this.noTex = false;
  this.customRatio = null;
  this.aspectRatio = "";
  this.aimFov = [true];
  this.adsFov = [1];
  this.objectAnim = true;
  this.rarityAnim = true;
  this.screenShake = true;
  this.textureAnim = true;
  this.weaponShine = true;
  this.lighting = 1;
  this.roundArms = false;
  this.reflectionQuality = 0;
  this.ropeColor = "#b3b3b3";
  this.trailColor = "#ededed";
  this.staticRendering = false;
  this.holidayEffects = false;
  this.getPlayerWeaponId = function (p7263) {
    if (p7263) {
      return (vThis47.vmSetts == 1 && p7263.currentWeaponId >= 0 ? p7263.currentWeaponId : -1) + 1;
    } else {
      return 0;
    }
  };
  this.aimRecticle = {
    image: new Image(),
    opacity: 0,
    opacMlt: 1,
    height: 680,
    width: 680,
    display: false,
    custom: false,
    savedCustom: ""
  };
  this.aimRecticle.image.onload = () => this.aimRecticle.image.isReady = true;
  this.aimRecticle.image.src = UTILS.assetsUrl("/textures/scopes/scope_0.png");
  this.aimDot = {
    image: new Image(),
    opacity: 0,
    width: 20,
    height: 20,
    display: false,
    custom: false,
    savedCustom: ""
  };
  this.aimDot.image.onload = () => this.aimDot.image.isReady = true;
  this.aimDot.image.src = UTILS.assetsUrl("/textures/reticles/reticle_0.png");
  this.missingTexture = new Image();
  this.missingTexture.src = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAACAgMAAAAP2OW3AAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAxQTFRF/wDbAAAAAAAA/wDbC5gN/AAAAAR0Uk5T/P/9/02rixUAAAAMSURBVHicYxBg2AAAAOQAwSeo6FcAAAAASUVORK5CYII=";
  var v6110 = true;
  this.lastEnvId = -1;
  this.init = function (p7264, p7265, p7266) {
    if (!p7266 && !v6110) {
      this.lastEnvId = -1;
      this.resetNormal();
      this.clearPendingMeshes();
      this.clearGeos();
    }
    this.pendingGIs = {};
    if (!p7266) {
      this.scene = new THREE.Scene();
      this.scene.name = "Main";
      this.backgroundScene = new THREE.Scene();
      this.backgroundScene.name = "Background";
    }
    this.clearSkyDome();
    if (p7264.skyDome && p7265 && p7265.skyCol == null) {
      this.skyDomeInit(p7264);
    }
    if (!p7266) {
      this.ocean = null;
      if (p7264.ocean) {
        this.ocean = Ocean.fromConfig(p7264, this);
        this.scene.add(this.ocean);
      }
    }
    this.sceneInit.apply(this, [p7264, p7265, p7266]);
    if (this.renderer) {
      var v6111 = p7264 && p7264.toneMapping != null ? UTILS.limitMM(p7264.toneMapping, 0, config.toneTypes.length - 1) : 0;
      this.renderer.toneMapping = THREE[config.toneTypes[v6111 || 0]];
      this.renderer.toneMappingExposure = p7264 && p7264.toneMappingExposure != null ? UTILS.limitMM(p7264.toneMappingExposure, 0, 10).round(1) : 1;
      var v6112 = p7264 && p7264.outputEncoding != null ? UTILS.limitMM(p7264.outputEncoding, 0, config.encodingTypes.length - 1) : 0;
      this.renderer.outputEncoding = THREE[config.encodingTypes[v6112 || 0].value];
      this.renderer.useLegacyLights = !p7264 || !p7264.correctLights;
    }
    this.initShaders();
    p7266;
  };
  this.clearSkyDome = function () {
    if (vThis47.skyDome) {
      vThis47.backgroundScene.remove(vThis47.skyDome);
      vThis47.skyDome = null;
    }
  };
  this.skyDomeInit = function (p7267) {
    vThis47.skyDome = SkyDome.fromConfig(p7267, vThis47);
    vThis47.backgroundScene.add(vThis47.skyDome);
  };
  this.getRes = function () {
    var v6113 = UTILS.isString(this.aspectRatio) ? this.aspectRatio.split("x") : [];
    return Math.abs(parseInt(v6113[0]) || window.innerWidth) / Math.abs(parseInt(v6113[1]) || window.innerHeight);
  };
  var vLN0969 = 0;
  this.flash = function (p7268, p7269) {
    if (p7238) {
      p7238.showFlash = true;
      p7238.flashX = p7268;
      p7238.flashY = 1 - p7269;
    }
    vLN0969 = 1;
  };
  this.updateLightMap = function (p7270) {
    if (this.skyLight) {
      this.skyLight.shadow.camera.right = p7270.shadWidth;
      this.skyLight.shadow.camera.left = -p7270.shadWidth;
      this.skyLight.shadow.camera.top = p7270.shadLength;
      this.skyLight.shadow.camera.bottom = -p7270.shadLength;
    }
  };
  if (!p7240) {
    this.renderer = new THREE.WebGLRenderer({
      powerPreference: "high-performance",
      antialias: getSavedVal("kro_setngss_antiAlias") == "true"
    });
    this.renderer.shadowMap.enabled = true;
    this.renderer.shadowMap.autoUpdate = false;
    this.renderer.shadowMap.type = THREE.BasicShadowMap;
    this.renderer.setPixelRatio(window.devicePixelRatio);
    this.renderer.setSize(window.innerWidth, window.innerHeight);
    this.renderer.autoClear = false;
    document.body.appendChild(this.renderer.domElement);
    delete this.renderer.domElement.dataset.engine;
    if (this.renderer.capabilities.isWebGL2 === false) {
      this.shaderRendering = false;
      this.ShaderMesh.enabled = false;
      this.ShaderMesh.supported = false;
    } else {
      var vO167 = {};
      var vA320 = ["build_0", "build_1", "build_2", "build_3"];
      var v6114 = prefabs.textures.length - 1 + vA320.length;
      var vLN0970 = 0;
      var vF43 = function () {
        vLN0970++;
        if (vLN0970 >= v6114) {
          vThis47.ShaderMesh.updateTextureMap(vO167);
        }
      };
      for (var vLN0972 = 0; vLN0972 < prefabs.textures.length; vLN0972++) {
        v6103 = prefabs.textures[vLN0972];
        if (v6103.src != "default") {
          vO167[v6103.src] = v6102.load(UTILS.assetsUrl("/textures/" + v6103.src + ".png"), vF43);
        }
      }
      for (var vLN0972 = 0; vLN0972 < vA320.length; vLN0972++) {
        vO167[vA320[vLN0972]] = v6102.load(UTILS.assetsUrl("/textures/" + vA320[vLN0972] + ".png"), vF43);
      }
    }
    if (v6087) {
      glS = new glStats();
      tS = new threeStats(this.renderer);
      rS = new rStats({
        values: {
          frame: {
            caption: "Total frame time (ms)",
            over: 16
          },
          fps: {
            caption: "Framerate (FPS)",
            below: 30
          },
          calls: {
            caption: "Calls (three.js)",
            over: 3000
          },
          raf: {
            caption: "Time since last rAF (ms)"
          },
          rstats: {
            caption: "rStats update (ms)"
          }
        },
        groups: [{
          caption: "Framerate",
          values: ["fps", "raf"]
        }, {
          caption: "Frame Budget",
          values: ["frame", "texture", "setup", "render"]
        }],
        fractions: [{
          base: "frame",
          steps: ["action1", "render"]
        }],
        plugins: [tS, glS]
      }, debugStats);
    }
  }
  this.postprocessing = {
    composer: null,
    enabled: true,
    active: false,
    shaders: [],
    shaderPasses: []
  };
  this.initShaders = function () {
    this.postprocessing.backgroundPass = undefined;
    this.postprocessing.scenePass = undefined;
    this.postprocessing.sceneAlwaysPass = undefined;
    this.postprocessing.sceneFPSPass = undefined;
    this.postprocessing.fixPass = undefined;
    this.postprocessing.composer = null;
    this.postprocessing.shaderPasses.length = 0;
    if (this.skyDome) {
      this.postprocessing.backgroundPass = new THREE.RenderPass(this.backgroundScene, this.camera);
      this.postprocessing.backgroundPass.layer = 0;
      this.postprocessing.backgroundPass.clear = false;
    }
    this.postprocessing.scenePass = new THREE.RenderPass(this.scene, this.camera);
    if (this.skyDome) {
      this.postprocessing.scenePass.layer = 0;
    }
    if (this.skyDome) {
      this.postprocessing.scenePass.clear = false;
    }
    this.postprocessing.sceneAlwaysPass = new THREE.RenderPass(this.scene, this.camera);
    this.postprocessing.sceneAlwaysPass.layer = 2;
    this.postprocessing.sceneAlwaysPass.clear = false;
    this.postprocessing.sceneFPSPass = new THREE.RenderPass(this.scene, this.fpsCamera);
    this.postprocessing.sceneFPSPass.clear = false;
    this.postprocessing.sceneFPSPass.clearDepth = true;
    this.postprocessing.fixPass = new THREE.ShaderPass(THREE.CopyShader);
    this.postprocessing.fixPass.enabled = true;
    this.postprocessing.composer = new THREE.EffectComposer(this.renderer, undefined, this);
    if (this.skyDome) {
      this.postprocessing.composer.addPass(this.postprocessing.backgroundPass);
    }
    this.postprocessing.composer.addPass(this.postprocessing.scenePass);
    this.postprocessing.composer.addPass(this.postprocessing.sceneAlwaysPass);
    this.postprocessing.composer.addPass(this.postprocessing.sceneFPSPass);
    this.postprocessing.composer.addPass(this.postprocessing.fixPass);
    for (var vLN0974 = 0; vLN0974 < this.postprocessing.shaders.length; vLN0974++) {
      v6103 = this.postprocessing.shaders[vLN0974];
      if (v6103) {
        if (v6103.ogUniforms && v6103.ogUniforms.resolution) {
          v6103.uniforms.resolution = {
            value: new THREE.Vector2(window.innerWidth, window.innerHeight)
          };
        }
        if (v6103.ogUniforms && v6103.ogUniforms.tDiffuse == null) {
          v6103.uniforms.tDiffuse = this.postprocessing.composer.renderTarget.texture;
        }
        this.postprocessing.shaderPasses[vLN0974] = new THREE.ShaderPass(v6103);
        this.postprocessing.composer.addPass(this.postprocessing.shaderPasses[vLN0974]);
      }
    }
    if (!v6110) {
      for (var vLN0974 = 0; vLN0974 < this.shaderInputs.length; vLN0974++) {
        v6103 = this.shaderInputs[vLN0974];
        var v6115;
        for (var vLN0975 = 0; vLN0975 < v6103.length; vLN0975++) {
          v6115 = v6103[vLN0975];
          if (v6115) {
            if (v6115.val == "false") {
              v6115.val = false;
            }
            if (v6115.val == "true") {
              v6115.val = true;
            }
            if (v6115.min || v6115.max) {
              v6115.val = Math.min(v6115.max, Math.max(v6115.min, +v6115.val));
            }
            if (v6115.toggle) {
              v6115.val = ~~!!v6115.val;
            }
            var v6116 = this.postprocessing.composer.passes.length - this.shaderInputs.length + vLN0974;
            if (vLN0975 == 0) {
              this.postprocessing.composer.passes[v6116].enabled = !!v6115.val;
            } else {
              this.postprocessing.composer.passes[v6116].uniforms[v6115.name].value = v6115.val;
            }
          }
        }
      }
    } else {
      v6110 = false;
    }
    this.resizeShaders();
  };
  this.shaderInputs = [];
  this.insertShaderPass = function (p7271) {
    try {
      var vO168 = {
        ...p7271.uniforms
      };
      if (p7271.uniforms.resolution) {
        p7271.uniforms.resolution = {
          value: new THREE.Vector2(window.innerWidth, window.innerHeight)
        };
      }
      if (p7271.uniforms.tDiffuse == null) {
        p7271.uniforms.tDiffuse = this.postprocessing.composer.renderTarget.texture;
      }
      var v6117 = this.shaderInputs.length;
      var vA321 = [{
        name: "Shader Mod # " + v6117 + 1,
        toggle: true,
        val: true
      }];
      for (var v6118 in p7271.uniforms) {
        v6103 = p7271.uniforms[v6118];
        if (v6103.user) {
          if (v6103.toggle) {
            vA321.push({
              name: v6118,
              toggle: true,
              val: v6103.value
            });
          } else {
            vA321.push({
              name: v6118,
              min: parseFloat(v6103.min) || 0,
              max: parseFloat(v6103.max) || 0,
              step: parseFloat(v6103.step) || 0,
              val: v6103.value
            });
          }
        }
      }
      this.shaderInputs.push(vA321);
      this.postprocessing.shaders.push({
        defines: Object.assign({}, p7271.defines),
        fragmentShader: p7271.fragmentShader,
        uniforms: p7271.uniforms,
        ogUniforms: vO168,
        vertexShader: p7271.vertexShader
      });
      if (!this.postprocessing.composer) {
        this.postprocessing.active = true;
        return;
      }
      this.postprocessing.shaderPasses[v6117] = new THREE.ShaderPass(this.postprocessing.shaders[v6117]);
      this.postprocessing.shaderPasses[v6117].enabled = true;
      this.postprocessing.composer.addPass(this.postprocessing.shaderPasses[v6117]);
      this.postprocessing.active = true;
    } catch (e65) {}
  };
  this.resetShaderPasses = function () {
    for (var v6119 = this.postprocessing.shaderPasses.length - 1; v6119 >= 0; v6119--) {
      this.postprocessing.composer.removePass(this.postprocessing.shaderPasses[v6119]);
    }
    this.shaderInputs.length = 0;
    this.postprocessing.shaders.length = 0;
    this.postprocessing.shaderPasses.length = 0;
    this.postprocessing.active = false;
  };
  this.resizeShaders = function () {
    if (this.postprocessing.composer) {
      var v6120 = this.renderer.getPixelRatio();
      var v6121 = Math.floor(window.innerWidth / v6120) || 1;
      var v6122 = Math.floor(window.innerHeight / v6120) || 1;
      this.postprocessing.composer.setSize(v6121, v6122);
    }
  };
  this.shadows = true;
  this.updateShadowMap = function () {
    if (this.shadows) {
      this.renderer.shadowMap.needsUpdate = true;
    }
  };
  this.toggleShadQual = function (p7272) {
    this.renderer.shadowMap.type = p7272 ? THREE.PCFSoftShadowMap : THREE.BasicShadowMap;
    if (this.skyLight) {
      this.renderer.setRenderTarget(this.skyLight.shadow.map);
      this.renderer.clear();
      this.renderer.setRenderTarget(null);
    }
    this.updateShadowMap();
  };
  this.toggleShadowMap = function (p7273) {
    if (p7273) {
      this.shadows = true;
      this.updateShadowMap();
    } else {
      this.shadows = false;
      if (this.skyLight) {
        this.renderer.setRenderTarget(this.skyLight.shadow.map);
        this.renderer.clear();
        this.renderer.setRenderTarget(null);
      }
    }
  };
  this.dynamicShadows = false;
  this.toggleShadowAuto = function (p7274) {
    this.dynamicShadows = p7274;
    this.renderer.shadowMap.autoUpdate = p7274;
    this.updateShadowMap();
  };
  this.setOrto = function (p7275, p7276) {
    vThis47.camera = p7275 ? v6108 : v6107;
    if (p7275) {
      vThis47.frustumSize = p7276;
      vThis47.resize();
    }
  };
  this.zoomVal = 1;
  this.zoom = function (p7277) {
    if (!this.aimFov) {
      p7277 = 1;
    }
    this.zoomVal = p7277;
    this.updateCamFOV();
    this.fpsCamera.fov = this.fpsFov / p7277;
    this.fpsCamera.updateProjectionMatrix();
  };
  this.fovMult = function (p7278) {
    if (this.fovMlt != p7278) {
      this.fovMlt = p7278;
      this.updateCamFOV();
    }
  };
  this.setFPSFov = function (p7279) {
    if (p7279 != this.fpsFov) {
      this.fpsFov = p7279;
      this.fpsCamera.fov = p7279;
      this.fpsCamera.updateProjectionMatrix();
    }
  };
  this.setFPSFov(config.fov);
  this.fovMlt = 1;
  this.updateCamFOV = function () {
    this.camera.fov = this.fov / this.zoomVal * this.fovMlt;
    this.camera.updateProjectionMatrix();
  };
  this.setFov = function (p7280) {
    if (p7280 != this.fov) {
      this.fov = p7280;
      this.updateCamFOV();
    }
  };
  this.setFov(config.fov);
  this.postprocessingEnabled = function () {
    return !this.shaderRendering && this.postprocessing.composer && this.postprocessing.enabled && this.postprocessing.active;
  };
  this.resize = function () {
    if (vThis47.camera.type == "PerspectiveCamera") {
      vThis47.camera.aspect = vThis47.getRes();
    } else {
      vThis47.camera.left = -vThis47.frustumSize * vThis47.getRes() / 2;
      vThis47.camera.right = vThis47.frustumSize * vThis47.getRes() / 2;
      vThis47.camera.top = vThis47.frustumSize / 2;
      vThis47.camera.bottom = -vThis47.frustumSize / 2;
    }
    vThis47.camera.updateProjectionMatrix();
    vThis47.fpsCamera.aspect = vThis47.getRes();
    vThis47.fpsCamera.updateProjectionMatrix();
    vThis47.renderer.setSize(window.innerWidth, window.innerHeight);
    vThis47.resizeShaders();
  };
  this.resMltV = 1;
  this.setResMlt = function (p7281) {
    this.resMltV = p7281;
    this.renderer.setPixelRatio(window.devicePixelRatio * this.resMltV);
    this.renderer.setSize(window.innerWidth, window.innerHeight);
  };
  this.updateFrustum = function () {
    this.frustum.setFromProjectionMatrix(v6106.multiplyMatrices(this.camera.projectionMatrix, this.camera.matrixWorldInverse));
  };
  var vLN0976 = 0;
  var vLN0977 = 0;
  this.shakeX = 0;
  this.swayX = 0;
  this.shakeY = 0;
  this.swayY = 0;
  this.updateShake = function (p7282) {
    if (vLN0977 && this.screenShake) {
      vLN0977 *= Math.pow(0.99, p7282);
      vLN0976 += UTILS.randFloat(-Math.PI, Math.PI);
      this.shakeY = Math.sin(vLN0976) * vLN0977;
      this.shakeX = Math.cos(vLN0976) * vLN0977;
      if (vLN0977 <= 0.01) {
        vLN0977 = 0;
        this.shakeX = this.shakeY = 0;
      }
    }
  };
  this.shake = function (p7283) {
    if (vLN0977 < p7283) {
      vLN0977 = p7283;
    }
  };
  this.render = function (p7284, p7285) {
    if (!this.dontRender && (!p7285 && v6087 && (rS("frame").start(), glS.start(), rS("frame").start(), rS("rAF").tick(), rS("FPS").frame()), this.scene || p7285)) {
      if (this.textureAnim) {
        for (var vLN0987 = 0; vLN0987 < this.movTextures.length; ++vLN0987) {
          v6103 = this.movTextures[vLN0987];
          if (v6103.tex.offset) {
            v6103.tex.offset[v6103.movD == 0 ? "x" : "y"] += v6103.mov * p7284;
          }
        }
        for (var vLN0987 = 0; vLN0987 < this.rotTextures.length; ++vLN0987) {
          v6103 = this.rotTextures[vLN0987];
          if (v6103.tex.rotation != null) {
            v6103.tex.rotation += v6103.rot * p7284;
          }
        }
        for (var vLN0987 = 0; vLN0987 < this.movMeshes.length; ++vLN0987) {
          v6103 = this.movMeshes[vLN0987];
          if (v6103 && v6103.mesh) {
            if (v6103.type) {
              v6103.bobAnim = (v6103.bobAnim || 0) + v6103.tim * p7284;
              v6103.mesh.position[v6103.axis] = v6103.orgP + Math.sin(v6103.bobAnim) * (v6103.mlt || 0.55);
            } else {
              v6103.mesh["rotate" + v6103.axis](v6103.tim * p7284);
            }
          }
        }
        this.pulsVal += p7284 * 0.003;
        var v6123;
        for (var vLN0987 = 0; vLN0987 < this.pulsMats.length; ++vLN0987) {
          v6123 = (Math.sin(this.pulsVal) / 2 + 0.5) * 1.5;
          v6123 += this.pulsMats[vLN0987].minGlo || 0;
          this.pulsMats[vLN0987].mat.emissiveIntensity = v6123;
        }
        for (var vLN0987 = 0; vLN0987 < this.frameMats.length; ++vLN0987) {
          v6103 = this.frameMats[vLN0987];
          v6103.dur -= p7284;
          if (v6103.dur <= 0) {
            v6103.dur = v6103.orgDur;
            v6103.cur++;
            if (v6103.cur >= v6103.total) {
              v6103.cur = 0;
            }
            if (v6103.mat.map) {
              v6103.mat.map.offset.x = v6103.cur % v6103.numX / v6103.numX;
              if (v6103.numY) {
                v6103.mat.map.offset.y = (v6103.numY - Math.floor(v6103.cur / v6103.numX) - 1) / v6103.numY;
              }
            }
          }
        }
        for (var vLN0987 = 0; vLN0987 < this.rgbMats.length; ++vLN0987) {
          v6103 = this.rgbMats[vLN0987];
          v6103.dlt += p7284 * v6103.mlt;
          if (v6103.dlt >= 360) {
            v6103.dlt = 0;
          }
          if (v6103.mat) {
            if (v6103.mat.type == "MeshBasicMaterial" && v6103.type != 1) {
              v6103.type = 1;
            }
            if (!v6103.mat[v6103.type ? "color" : "emissive"]) {
              v6103.mat[v6103.type ? "color" : "emissive"] = new THREE.Color();
            }
            v6103.mat[v6103.type ? "color" : "emissive"].set(UTILS.hexFromHue(Math.round(v6103.dlt)));
          }
        }
      }
      if (this.objectAnim) {
        this.liquidVal += p7284 * 0.003;
        this.liquidUpd -= p7284;
        if (this.liquidUpd <= 0 && (this.liquidUpd = this.liquidFreq, v6104 && (v6104.uniforms.time.value = this.liquidVal), !this.newliquid)) {
          for (var vLN0987 = 0; vLN0987 < this.liquids.length; ++vLN0987) {
            v6103 = this.liquids[vLN0987];
            for (var v6124 = v6103.mesh.geometry.getAttribute("position"), vLN0985 = 0; vLN0985 < v6124.count; vLN0985++) {
              v6124.setZ(vLN0985, v6103.hght * Math.sin(vLN0985 / 5 + this.liquidVal * v6103.spd / 4));
            }
            v6103.mesh.geometry.attributes.position.needsUpdate = true;
            v6103.mesh.geometry.computeVertexNormals();
          }
        }
        for (var vLN0987 = 0; vLN0987 < vA326.length; ++vLN0987) {
          v6103 = vA326[vLN0987];
          vA326[vLN0987].mixer.update(p7284 / 1000);
        }
      }
      this.rendDisCnt -= p7284;
      if (this.rendDisCnt <= 0) {
        this.camera.getWorldPosition(v6091);
        this.rendDisCnt = 500;
        for (var vLN0987 = 0; vLN0987 < this.rendDisObjs.length; ++vLN0987) {
          v6103 = this.rendDisObjs[vLN0987];
          if (v6103.ms) {
            v6103.ms.visible = UTILS.getD3D(v6103.ms.position.x, v6103.ms.position.y, v6103.ms.position.z, v6091.x, v6091.y, v6091.z) <= v6103.dis;
          }
        }
      }
      if (this.ocean) {
        this.ocean.update(p7284);
      }
      if (!p7285) {
        if (v6087) {
          rS("render").start();
        }
        this.renderer.clear();
        this.camera.layers.set(0);
        if (this.skyDome) {
          this.camera.getWorldPosition(this.skyDome.position);
        }
        if (this.postprocessingEnabled()) {
          this.postprocessing.composer.render(p7284);
        } else {
          if (this.skyDome) {
            this.renderer.render(this.backgroundScene, this.camera);
            this.renderer.clearDepth();
          }
          this.renderer.render(this.scene, this.camera);
          this.renderer.clearDepth();
          this.renderer.render(this.scene, this.fpsCamera);
        }
        if (v6087) {
          rS("render").end();
        }
        if (p7238 && p7238.showFlash) {
          if (vLN0969 <= 0) {
            vLN0969 = 0;
            p7238.showFlash = false;
          }
          vLN0969 -= p7284;
        }
        this.updateShake(p7284);
        if (v6087) {
          rS("frame").end();
          rS().update();
        }
      }
    }
  };
  this.updateTexture = function (p7286, p7287, p7288) {
    p7288 = p7288 || {};
    var v6125 = new THREE.Texture(p7287);
    for (var v6126 in vO163) {
      if (!v6126.includes("sad") && v6126.substring(0, p7286.length + 2) == p7286 + "mt") {
        try {
          vO163[v6126].dispose();
        } catch (e66) {}
        vO163[v6126].image = v6125.image;
        vO163[v6126].needsUpdate = true;
      }
    }
    vO164[p7286] = v6125;
  };
  this.loadTexture = function (p7289, p7290, p7291, p7292) {
    p7291 = p7291 || {};
    var v6127 = p7290 + (p7291.movT == null ? "mt" : "mt" + p7291.movT) + (p7291.movD == null ? "md" : p7291.movD) + (p7291.rotT == null ? "rt" : "rt" + p7291.rotT) + (p7291.fontSize || "fs") + (p7291.fcolr || "fc") + (p7291.bcolr || "bc") + (p7291.noBVis || "bv") + (p7291.text || "txt") + (p7291.tAlign || "ta") + (p7291.tId || "ctx") + (p7291.texOffX || "tox") + (p7291.texOffY || "toy") + (p7291.normal || "n") + (p7291.spec || "spec") + (p7291.asset || "as") + (p7291.umid || "umid") + (p7291.texRot || "tr") + (p7291.texEncode || "en") + (p7291.metalness || "mtl") + (p7291.roughness || "rg") + (p7291.displacement || "dp") + (p7291.bump || "bp") + (p7291.video == null ? "" : "v_" + p7291.video) + (p7291.lightM || "lm") + (p7291.env == null ? "" : "env_" + p7291.env) + (p7291.frames == null ? "" : "fr" + p7291.frames) + (p7291.frameT == null ? "" : "frt" + p7291.frameT) + (p7291.fTrans ? "fT" : "") + p7291.texExt;
    var v6128 = p7291.frames || 0;
    var v6129 = Math.min(10, v6128);
    var v6130 = v6128 > 10 ? Math.ceil(v6128 / 10) : 0;
    if (vO163[v6127]) {
      if (vO163[v6127].mats) {
        vO163[v6127].mats.push({
          t: p7292,
          m: p7289
        });
      } else {
        p7289[p7292 || "map"] = vO163[v6127];
        if (p7291.frames && p7289.map.repeat.x == 1) {
          p7289.map.repeat.x = 1 / p7291.frames;
        }
        p7289.needsUpdate = true;
      }
    } else {
      vO163[v6127] = {
        mats: [{
          t: p7292,
          m: p7289
        }]
      };
      if (vO164[p7290]) {
        var v6135 = vO164[p7290];
        v6135.wrapS = THREE.RepeatWrapping;
        v6135.wrapT = THREE.RepeatWrapping;
        v6135.repeat.set(v6128 ? 1 / v6129 : p7291.repeatX || 1, v6130 ? 1 / v6130 : p7291.repeatY || 1);
        v6135.minFilter = p7291.tFilter || THREE.NearestFilter;
        v6135.magFilter = p7291.tFilter || THREE.NearestFilter;
        v6135.offset.x = (p7291.texOffX || 0).round(2);
        v6135.offset.y = (p7291.texOffY || 0).round(2);
        v6135.rotation = UTILS.toRad(p7291.texRot || 0);
        v6135.encoding = THREE[config.encodingTypes[p7291.texEncode || 0].value];
        v6135.needsUpdate = true;
        for (var vLN0993 = 0; vLN0993 < vO163[v6127].mats.length; ++vLN0993) {
          vO163[v6127].mats[vLN0993].m[vO163[v6127].mats[vLN0993].t || "map"] = v6135;
          vO163[v6127].mats[vLN0993].m.needsUpdate = true;
        }
        vO163[v6127] = v6135;
        if (p7291.movT) {
          vThis47.movTextures.push({
            tex: v6135,
            mov: p7291.movT,
            movD: p7291.movD || 0
          });
        }
        if (p7291.rotT) {
          vThis47.rotTextures.push({
            tex: v6135,
            rot: p7291.rotT
          });
        }
      } else if (p7292 && p7292 == "emissiveMap" && p7291.noEmisTex) {
        ;
      } else if (p7291.canvas) {
        var v6135 = new THREE.Texture(p7291.canvas);
        v6135.wrapS = THREE.RepeatWrapping;
        v6135.wrapT = THREE.RepeatWrapping;
        v6135.repeat.set(p7291.repeatX || 1, p7291.repeatY || 1);
        v6135.minFilter = p7291.tFilter || THREE.NearestFilter;
        v6135.magFilter = p7291.tFilter || THREE.NearestFilter;
        v6135.encoding = THREE[config.encodingTypes[p7291.texEncode || 0].value];
        v6135.needsUpdate = true;
        for (var vLN0993 = 0; vLN0993 < vO163[v6127].mats.length; ++vLN0993) {
          vO163[v6127].mats[vLN0993].m[vO163[v6127].mats[vLN0993].t || "map"] = v6135;
          vO163[v6127].mats[vLN0993].m.needsUpdate = true;
        }
        vO163[v6127] = v6135;
        if (p7291.movT) {
          vThis47.movTextures.push({
            tex: v6135,
            mov: p7291.movT,
            movD: p7291.movD || 0
          });
        }
        if (p7291.rotT) {
          vThis47.rotTextures.push({
            tex: v6135,
            rot: p7291.rotT
          });
        }
      } else if (p7291.video != null) {
        var v6135 = new THREE.VideoTexture(vThis47.getVideo(p7291));
        v6135.wrapS = THREE.RepeatWrapping;
        v6135.wrapT = THREE.RepeatWrapping;
        v6135.repeat.set(p7291.repeatX || 1, p7291.repeatY || 1);
        if (!p7291.projection) {
          v6135.minFilter = p7291.tFilter || THREE.NearestFilter;
          v6135.magFilter = p7291.tFilter || THREE.NearestFilter;
          v6135.encoding = THREE[config.encodingTypes[p7291.texEncode || 0].value];
          v6135.needsUpdate = true;
        }
        for (var vLN0993 = 0; vLN0993 < vO163[v6127].mats.length; ++vLN0993) {
          vO163[v6127].mats[vLN0993].m[vO163[v6127].mats[vLN0993].t || "map"] = v6135;
          vO163[v6127].mats[vLN0993].m.needsUpdate = true;
        }
        vO163[v6127] = v6135;
        if (p7291.movT) {
          vThis47.movTextures.push({
            tex: v6135,
            mov: p7291.movT,
            movD: p7291.movD || 0
          });
        }
        if (p7291.rotT) {
          vThis47.rotTextures.push({
            tex: v6135,
            rot: p7291.rotT
          });
        }
      } else if (typeof p7290 != "string" || !p7290.includes("custom_")) {
        if (typeof p7290 == "string" && !p7290.includes("default")) {
          v6102.load(p7291.asset ? UTILS.userAssetsUrl(p7290 + "." + (p7291.texExt || "png"), false, false, true) : UTILS.assetsUrl("/textures/" + p7290 + "." + (p7291.texExt || "png"), false, p7291.local), p7293 => {
            p7293.wrapS = THREE.RepeatWrapping;
            p7293.wrapT = THREE.RepeatWrapping;
            p7293.repeat.set(v6128 ? 1 / v6129 : p7291.repeatX || 1, v6130 ? 1 / v6130 : p7291.repeatY || 1);
            p7293.minFilter = p7291.tFilter || THREE.NearestFilter;
            p7293.magFilter = p7291.tFilter || THREE.NearestFilter;
            p7293.offset.x = (p7291.texOffX || 0).round(2);
            p7293.offset.y = (p7291.texOffY || 0).round(2);
            p7293.rotation = UTILS.toRad(p7291.texRot || 0);
            p7293.encoding = THREE[config.encodingTypes[p7291.texEncode || 0].value];
            p7293.mapping = THREE[config.mappingTypes[p7291.mapping || 0]];
            p7293.needsUpdate = true;
            for (var vLN0991 = 0; vLN0991 < vO163[v6127].mats.length; ++vLN0991) {
              vO163[v6127].mats[vLN0991].m[vO163[v6127].mats[vLN0991].t || "map"] = p7293;
              vO163[v6127].mats[vLN0991].m.needsUpdate = true;
            }
            vO163[v6127] = p7293;
            if (p7291.movT) {
              vThis47.movTextures.push({
                tex: p7293,
                mov: p7291.movT,
                movD: p7291.movD || 0
              });
            }
            if (p7291.rotT) {
              vThis47.rotTextures.push({
                tex: p7293,
                rot: p7291.rotT
              });
            }
          }, undefined, function () {
            if (!p7292) {
              var v6134 = new THREE.Texture(vThis47.missingTexture);
              v6134.wrapS = THREE.RepeatWrapping;
              v6134.wrapT = THREE.RepeatWrapping;
              v6134.repeat.set(v6128 ? 1 / v6129 : p7291.repeatX || 1, v6130 ? 1 / v6130 : p7291.repeatY || 1);
              v6134.minFilter = p7291.tFilter || THREE.NearestFilter;
              v6134.magFilter = p7291.tFilter || THREE.NearestFilter;
              v6134.offset.x = (p7291.texOffX || 0).round(2);
              v6134.offset.y = (p7291.texOffY || 0).round(2);
              v6134.rotation = UTILS.toRad(p7291.texRot || 0);
              v6134.encoding = THREE[config.encodingTypes[p7291.texEncode || 0].value];
              v6134.needsUpdate = true;
              for (var vLN0992 = 0; vLN0992 < vO163[v6127].mats.length; ++vLN0992) {
                vO163[v6127].mats[vLN0992].m[vO163[v6127].mats[vLN0992].t || "map"] = v6134;
                vO163[v6127].mats[vLN0992].m.needsUpdate = true;
              }
              vO163[v6127] = v6134;
              if (p7291.movT) {
                vThis47.movTextures.push({
                  tex: v6134,
                  mov: p7291.movT,
                  movD: p7291.movD || 0
                });
              }
              if (p7291.rotT) {
                vThis47.rotTextures.push({
                  tex: v6134,
                  rot: p7291.rotT
                });
              }
            }
          });
        }
      } else if (!p7292) {
        var v6135 = new THREE.Texture(vThis47.missingTexture);
        v6135.wrapS = THREE.RepeatWrapping;
        v6135.wrapT = THREE.RepeatWrapping;
        v6135.repeat.set(v6128 ? 1 / v6129 : p7291.repeatX || 1, v6130 ? 1 / v6130 : p7291.repeatY || 1);
        v6135.minFilter = p7291.tFilter || THREE.NearestFilter;
        v6135.magFilter = p7291.tFilter || THREE.NearestFilter;
        v6135.offset.x = (p7291.texOffX || 0).round(2);
        v6135.offset.y = (p7291.texOffY || 0).round(2);
        v6135.rotation = UTILS.toRad(p7291.texRot || 0);
        v6135.encoding = THREE[config.encodingTypes[p7291.texEncode || 0].value];
        v6135.needsUpdate = true;
        for (var vLN0993 = 0; vLN0993 < vO163[v6127].mats.length; ++vLN0993) {
          vO163[v6127].mats[vLN0993].m[vO163[v6127].mats[vLN0993].t || "map"] = v6135;
          vO163[v6127].mats[vLN0993].m.needsUpdate = true;
        }
        vO163[v6127] = v6135;
        if (p7291.movT) {
          vThis47.movTextures.push({
            tex: v6135,
            mov: p7291.movT,
            movD: p7291.movD || 0
          });
        }
        if (p7291.rotT) {
          vThis47.rotTextures.push({
            tex: v6135,
            rot: p7291.rotT
          });
        }
      }
    }
    return p7289;
  };
  this.getVideo = function (p7294) {
    var v6136 = document.getElementById("video_" + (p7294.video || 0));
    if (!v6136) {
      v6136 = document.createElement("video");
      v6136.crossOrigin = "anonymous";
      v6136.id = "video_" + (p7294.video || 0);
      v6136.src = p7294.asset ? UTILS.userAssetsUrl(p7294.src + ".mp4") : UTILS.assetsUrl("/videos/video_" + (p7294.video || 0) + ".mp4");
      v6136.style.display = "none";
      document.body.appendChild(v6136);
      v6136.loop = true;
      v6136.volume = 0;
      v6136.play();
    }
    return v6136;
  };
  this.getMat = function (p7295, p7296) {
    p7296 = p7296 || {};
    if (vThis47.lighting == 0 && p7296.mat != THREE.SpriteMaterial) {
      p7296.mat = THREE.MeshBasicMaterial;
    }
    if (vThis47.lighting == 2 && p7296.mat != THREE.SpriteMaterial) {
      p7296.mat = THREE.MeshPhongMaterial;
    }
    if (vThis47.lighting == 3 && p7296.mat != THREE.SpriteMaterial) {
      p7296.mat = THREE.MeshStandardMaterial;
    }
    if (p7296.forceMat) {
      p7296.mat = p7296.forceMat;
    }
    if (p7296.video != null && !p7296.asset) {
      p7295 = "/videos/video_" + (p7296.video || 0);
    }
    var v6137 = !!p7296.isMdl && !!(vThis47.lighting >= 2) && p7296.mat != THREE.SpriteMaterial;
    p7296.texExt = p7296.texExt || "png";
    var v6138 = (p7296.texSrc || p7295) + (p7296 ? (p7296.rotation || "x") + (p7296.noFog || "y") + (p7296.umid || "umid") + (p7296.opacity || "z") + (p7296.color || "b") + (p7296.mat ? "ma" : "nm") + (p7296.ao || "a") + (p7296.emissive || "e") + (p7296.glowText || "g") + (p7296.movT == null ? "mt" : p7296.movT) + (p7296.movD == null ? "md" : p7296.movD) + (p7296.canvas == null ? "" : "canvas") + (p7296.rotT == null ? "rt" : p7296.rotT) + (p7296.blending == null ? "nb" : p7296.blending) + (p7296.pulsT ? "pt" + p7296.pulsT : "npt") + (p7296.normal || "n") + (p7296.spec || "spec") + (p7296.alph || "alph") + (p7296.asset || "as") + +(p7296.frames == null ? "nfr" : "fr" + p7296.frames) + (p7296.frameT == null ? "nfrt" : "frt" + p7296.frameT) + (p7296.rAnim == null ? "nra" : "ra" + p7296.rAnim) + (p7296.rAnimA == null ? "nraa" : "raa" + p7296.rAnimA) + (p7296.rAnimT == null ? "nrt" : "rt" + p7296.rAnimT) + (p7296.texRot || "tr") + (p7296.texEncode == null ? "" : "en_" + p7296.texEncode) + (p7296.rAnimM == null ? "" : "rm" + p7296.rAnimM) + (p7296.depthWrite == null ? "d" : p7296.depthWrite) + (p7296.fontSize || "fs") + (p7296.fcolr || "fc") + (p7296.bcolr || "bc") + (p7296.noBVis || "bv") + (p7296.text || "txt") + (p7296.tAlign || "ta") + (p7296.rgb ? "rgb" : "nrgb") + (p7296.rgbS ? "rgbS" : "nrgbS") + (p7296.rgbT || "rgbT") + (p7296.texOffX || "tox") + (p7296.texOffY || "toy") + (p7296.itemID || "itemID") + (p7296.useWireframe ? "wf" : "nwf") + (p7296.metalness || "mtl") + (p7296.roughness || "rg") + (p7296.displacement || "dp") + (p7296.bump || "bp") + (p7296.emissInt || "") + (p7296.projection ? "pj" : "") + (p7296.video == null ? "" : "v_" + p7296.video) + (p7296.lightM || "lm") + (p7296.side == null ? "" : "side_" + p7296.side) + (p7296.rside == null ? "" : "side_" + p7296.rside) + (p7296.fTrans ? "fT" : "") + (p7296.noTex ? "nt" : "") + p7296.texExt : "");
    var v6139 = vO162[v6138];
    if (!v6139) {
      if (p7296.noTex) {
        p7295 = "default";
        p7296.color = "#ffffff";
      }
      if (v6137) {
        delete p7296.vertexColors;
      }
      const v6140 = p7296.shaderNum != null && shaders[p7296.shaderNum];
      if (v6140) {
        v6139 = new THREE.ShaderToyMaterial(shaders[p7296.shaderNum].code, p7296);
        if (p7296.side != null) {
          v6139.side = p7296.side;
        }
      } else {
        v6139 = new (p7296.mat ? p7296.mat : THREE.StrippedLambertMaterial)(p7296);
      }
      if (p7296.rside != null) {
        v6139.side = p7296.rside;
      }
      if (p7296 && p7296.rgb) {
        v6139.dithering = true;
      }
      if (p7296.canvas) {
        this.loadTexture(v6139, v6138, p7296);
      }
      if (!!p7295 && p7295 != "default" && !p7296.useWireframe && !v6140) {
        this.loadTexture(v6139, p7296.texSrc || p7295, p7296);
      }
      const v6141 = v6139.hasOwnProperty("emissiveMap");
      const v6142 = v6139.hasOwnProperty("normalMap");
      const v6143 = v6139.hasOwnProperty("roughnessMap");
      const v6144 = v6139.hasOwnProperty("metalnessMap");
      const v6145 = v6139.hasOwnProperty("displacementMap");
      const v6146 = v6139.hasOwnProperty("specularMap");
      const v6147 = v6139.hasOwnProperty("bumpMap");
      const v6148 = v6139.hasOwnProperty("envMap");
      const v6149 = v6139.hasOwnProperty("alphaMap");
      if (p7296 && p7296.emissive && v6141) {
        this.loadTexture(v6139, (p7296.glowText ? p7296.texSrc || p7295 : p7295) + (p7296.sameGlow ? "" : "_e"), p7296, "emissiveMap");
      }
      if (p7296 && p7296.emissInt && v6141) {
        v6139.emissiveIntensity = p7296.emissInt;
      }
      if (p7296 && p7296.ao) {
        this.loadTexture(v6139, p7295 + "_ao", p7296, "aoMap");
        v6139.aoMapIntensity = 1.3;
      }
      if (p7296 && p7296.lightM) {
        this.loadTexture(v6139, p7295 + "_l", p7296, "lightMap");
        v6139.lightMapIntensity = 1.5;
      }
      if (p7296 && p7296.normal && v6142) {
        this.loadTexture(v6139, (p7296.texSrc || p7295) + "_n", p7296, "normalMap");
      }
      if (p7296 && p7296.roughness && v6143) {
        this.loadTexture(v6139, (p7296.texSrc || p7295) + "_r", p7296, "roughnessMap");
      }
      if (p7296 && p7296.metalness && v6144) {
        this.loadTexture(v6139, (p7296.texSrc || p7295) + "_m", p7296, "metalnessMap");
      }
      if (p7296 && p7296.displacement && v6145) {
        this.loadTexture(v6139, (p7296.texSrc || p7295) + "_d", p7296, "displacementMap");
        v6139.displacementScale = p7296.displacement;
      }
      if (p7296 && p7296.bump && v6147) {
        this.loadTexture(v6139, (p7296.texSrc || p7295) + "_b", p7296, "bumpMap");
        v6139.bumpScale = p7296.bump;
      }
      if (p7296 && p7296.spec && v6139.type != "MeshStandardMaterial" && v6146) {
        this.loadTexture(v6139, (p7296.texSrc || p7295) + "_s", p7296, "specularMap");
      }
      if (p7296 && p7296.alph && v6149) {
        this.loadTexture(v6139, (p7296.texSrc || p7295) + "_a", p7296, "alphaMap");
      }
      if (p7296.env && v6148) {
        p7296.mapping = 3;
        this.loadTexture(v6139, (p7296.texSrc || p7295) + (p7296.sameEnv ? "" : "_env"), p7296, "envMap");
        v6139.envMapIntensity = p7296.env || 3;
      }
      if (p7295 == "default" && p7296.vertexColors !== false || p7296 && p7296.rgb && !p7296.rgbT) {
        v6139.vertexColors = true;
      }
      if (p7296.vertexColors === false) {
        v6139.vertexColors = false;
      }
      if (p7296 && p7296.noFog) {
        v6139.fog = false;
      }
      if (v6139.hasOwnProperty("shading")) {
        v6139.shading = THREE.SmoothShading;
      }
      if (p7296.pulsT && v6141) {
        vThis47.pulsMats.push({
          mat: v6139,
          pul: p7296.pulsT,
          minGlo: p7296.minGlo
        });
      }
      if (p7296.projection) {
        v6139.side = THREE.DoubleSide;
        v6139.onBeforeCompile = p7297 => {
          p7297.fragmentShader = "\n\t\t\t\t\t\tvarying vec4 vTexCoords;\n\t\t\t\t\t" + p7297.fragmentShader.replace("void main() {", "void main() {\n\t\t\t\t\t\t\tvec2 uvT = vTexCoords.xy / vTexCoords.w / 2.0 + 0.5;").replace("#include <map_fragment>", THREE.ShaderChunk.map_fragment.replace(/texture2D\( (\w+), (\w+) \);/gmi, "texture2D($1,uvT);")).replace("#include <map_particle_fragment>", THREE.ShaderChunk.map_particle_fragment.replace(/texture2D\( (\w+), (\w+) \);/gmi, "texture2D($1,uvT);")).replace("#include <emissivemap_fragment>", THREE.ShaderChunk.emissivemap_fragment.replace(/texture2D\( (\w+), (\w+) \);/gmi, "texture2D($1,uvT);"));
          p7297.vertexShader = "\n\t\t\t\t\t\tvarying vec4 vTexCoords;\n\t\t\t\t\t" + p7297.vertexShader.replace("#include <fog_vertex>", "\n\t\t\t\t\t\t#include <fog_vertex>\n\t\t\t\t\t\tvTexCoords = projectionMatrix * modelViewMatrix * vec4(position, 1.0);\n\t\t\t\t\t\tgl_Position = vTexCoords;\n\n\t\t\t\t\t\t// TRANSFORM AFTER TO PREVENT ISSUES:\n\t\t\t\t\t\t#ifdef USE_UV\n\t\t\t\t\t\t\tvTexCoords = vec4( uvTransform * vTexCoords.xyz, vTexCoords.w);\n\t\t\t\t\t\t#endif\n\t\t\t\t\t");
        };
      }
      if (p7296.wSpeed && this.newliquid) {
        v6139.onBeforeCompile = p7298 => {
          p7298.uniforms.time = {
            value: 0
          };
          p7298.uniforms.hght = {
            value: p7296.wHeight
          };
          p7298.uniforms.spd = {
            value: p7296.wSpeed
          };
          p7298.vertexShader = "\n\t\t\t\t\tuniform float time;\n\t\t\t\t\tuniform float hght ;\n\t\t\t\t\tuniform float spd;\n\t\t\t\t\tattribute float count;\n\t\t\t\t\t" + p7298.vertexShader;
          p7298.vertexShader = p7298.vertexShader.replace("#include <begin_vertex>", "\n\t\t\t\t\t   \n\t\t\t\t\t\tvec3 transformed = vec3(position);\n\t\t\t\t\t\n\t\t\t\t\t\tfloat freq = spd / 4.0;\n\t\t\t\t\t\tfloat currentCount = count / 5.0;\n\t\t\t\t\t\tfloat angle =  currentCount + (time * (freq));\t\t\n\t\t\t\t\t\ttransformed.z =  hght  * sin(angle);\n\t\t\t\t\t\tobjectNormal = normalize(vec3(0.0,hght * cos(angle),1.0));\n\t\t\t\t\t\tvNormal = normalMatrix * objectNormal;\n\t\t\t\t\t\t");
          p7298.fragmentShader = p7298.fragmentShader.replace("#include <normal_fragment_begin>", "vec3 normal =vNormal;");
          v6104 = p7298;
        };
      }
      var v6150 = p7296.frames || 0;
      var v6151 = Math.min(10, v6150);
      var v6152 = v6150 > 10 ? Math.ceil(v6150 / 10) : 0;
      if (v6150 && p7296.frameT && !p7296.noAutoAnim && !this.frameMats.find(p7299 => p7299.indx == v6138)) {
        this.frameMats.push({
          mat: v6139,
          indx: v6138,
          numX: v6151,
          numY: v6152,
          cur: 0,
          total: v6150,
          dur: p7296.frameT,
          orgDur: p7296.frameT
        });
      }
      if (p7296.rgb) {
        this.rgbMats.push({
          mat: v6139,
          mlt: p7296.rgbS || 0.3,
          type: p7296.rgbT || 0,
          dlt: 0
        });
      }
      vO162[v6138] = v6139;
    }
    return v6139;
  };
  this.genColorCube = function (p7300, p7301, p7302, p7303, p7304, p7305) {
    p7305 = p7305 || {};
    var v6153 = p7305.us ? "us" : "ns";
    for (var vLN0996 = 0; vLN0996 < p7303.length; ++vLN0996) {
      for (var vLN0995 = 0; vLN0995 < p7303[vLN0996].length; ++vLN0995) {
        v6153 += p7303[vLN0996][vLN0995] + "_";
      }
      v6153 += "|";
    }
    var v6154 = vO165[v6153];
    if (!v6154) {
      v6154 = new THREE.BufferGeometry();
      var v6155 = 0.5 + (p7304 || 0);
      for (var vLN0996 = 0; vLN0996 < p7303.length; ++vLN0996) {
        var v6156 = p7303[vLN0996][1];
        var v6157 = p7303[vLN0996][2] || 1;
        if (p7303[vLN0996][5]) {
          v6155 -= v6156;
          continue;
        }
        var v6161;
        if (!p7305.uvScale && !p7305.us) {
          var v6160 = new THREE.BoxGeometry(v6157, v6156, v6157);
          vThis47.GEOS.colorize(v6160, p7303[vLN0996][0]);
          v6161 = new THREE.Mesh(v6160);
          vThis47.moveMesh(v6161, 0, v6155 - v6156 / 2, 0);
        } else {
          var v6160;
          if (p7305.cyl) {
            v6160 = vThis47.GEOS.generateCylinder(v6157, v6156, v6157, {
              colr: p7303[vLN0996][0],
              fAmb: p7303[vLN0996][4],
              amb: p7303[vLN0996][3]
            });
            v6157 /= 2;
          } else {
            v6160 = vThis47.GEOS.generateCube([1, 1, 1, 1, 1, 1], v6157 / 2 * p7300, v6156 / 2 * p7301, v6157 / 2 * p7302, {
              colr: p7303[vLN0996][0],
              fAmb: p7303[vLN0996][4],
              scale: p7305.uvScale || 15,
              noAmb: p7305.noAmb,
              amb: p7303[vLN0996][3]
            });
          }
          v6161 = new THREE.Mesh(v6160);
          v6161.scale.set(v6157, v6156, v6157);
          vThis47.moveMesh(v6161, 0, v6155 - v6156, 0);
        }
        v6154 = vThis47.merge(v6154, v6161);
        v6155 -= v6156;
      }
      vO165[v6153] = v6154;
    }
    var v6161 = new THREE.Mesh(v6154, vThis47.getMat(p7305.src || "default", p7305));
    vThis47.scaleMesh(v6161, p7300, p7301, p7302);
    return v6161;
  };
  var vO169 = {};
  this.genLeg = function (p7306, p7307, p7308, p7309) {
    p7309 = p7309 || {};
    p7309.us = p7309.det;
    var v6162 = config.legScale;
    var v6172 = null;
    if (p7309.crouch) {
      var v6164 = (p7309.texSrc || "default") + (p7307 + "-" + p7308 + "-" + (p7309.crouch || "") + "-" + (p7309.rgb ? "rgb" : "") + (p7309.legLen ? "legLen" + p7309.legLen : "") + (p7309.movT == null ? "mt" : p7309.movT) + (p7309.movD == null ? "md" : p7309.movD) + (p7309.rotT == null ? "rt" : p7309.rotT) + (p7309.projection == null ? "" : "pj_" + p7309.projection) + (p7309.video == null ? "" : "v_" + p7309.video));
      v6172 = vO169[v6164];
      if (!v6172) {
        var v6165 = config.legHeight / 2;
        var v6166 = v6162 / 2;
        var vA322 = [0.5, 2];
        var v6167 = this.genColorCube(v6162, v6165, v6162, [[p7307, 1]], 0, {
          us: p7309.det,
          uvScale: p7309.uvScale
        });
        this.moveMesh(v6167, 0, -(v6165 / 2 * Math.cos(vA322[1])), -(v6165 / 2 * Math.sin(vA322[1])));
        this.rotateMesh(v6167, 0, vA322[1], 0);
        var v6168 = Math.sqrt(v6166 * v6166 + v6166 * v6166 - v6166 * 2 * v6166 * Math.cos(vA322[0] - vA322[1]));
        var v6169 = Math.sqrt(v6166 * v6166 - v6168 / 2 * (v6168 / 2)) * 2;
        var v6170 = this.genColorCube(v6162, v6168, v6169, [[p7307, 1]], 0, {
          us: p7309.det,
          uvScale: p7309.uvScale
        });
        this.moveMesh(v6170, 0, -(v6165 * Math.cos(vA322[1])), -(v6165 * Math.sin(vA322[1])));
        this.rotateMesh(v6170, 0, (vA322[1] + vA322[0]) / 2, 0);
        var v6171 = this.genColorCube(v6162, v6165, v6162, [[p7307, 0.5, 1, 0.8], [p7308, 0.5]], 0, {
          us: p7309.det,
          uvScale: p7309.uvScale
        });
        this.moveMesh(v6171, 0, -v6165 * Math.cos(vA322[1]) - v6165 / 2 * Math.cos(vA322[0]), -v6165 * Math.sin(vA322[1]) - v6165 / 2 * Math.sin(vA322[0]));
        this.rotateMesh(v6171, 0, vA322[0], 0);
        var v6172 = new THREE.BufferGeometry();
        v6172 = this.merge(v6172, v6167);
        v6172 = this.merge(v6172, v6170);
        v6172 = this.merge(v6172, v6171);
        vO169[v6164] = v6172;
      }
      v6172 = THREE.BufferGeometryUtils.mergeVertices(v6172);
      v6172 = new THREE.Mesh(v6172, this.getMat(p7309.texSrc || "default", p7309));
      this.moveMesh(v6172, config.legScale / 2 * (p7306 ? -1 : 1), config.legHeight - config.crouchDst + 0.5, 0);
    } else {
      v6172 = this.genColorCube(v6162, config.legHeight, v6162, [[p7307, p7309.legLen ? p7309.legLen : 0.75, 1], [p7308, p7309.legLen ? 1 - p7309.legLen : 0.25, undefined, undefined, undefined, p7309.legLen]], -0.5, p7309);
      this.moveMesh(v6172, config.legScale / 2 * (p7306 ? -1 : 1), config.legHeight, 0);
    }
    v6172.receiveShadow = true;
    v6172.castShadow = this.dynamicShadows;
    return v6172;
  };
  var vO170 = {};
  this.genBody = function (p7310, p7311) {
    p7311 = p7311 || {};
    var v6173 = (p7311.texSrc || "default") + (p7311.shirtCol + "-" + p7311.pantsCol + "-" + p7311.hairCol + "-" + p7311.waistCol + "-" + p7311.skinCol + "-" + (p7311.rgb ? "rgb" : "") + "-" + (p7311.noHead ? "nh" : "") + "-" + (p7311.noHair ? "nhr" : "") + "-" + (p7311.noBody ? "nb" : "") + (p7311.movT == null ? "mt" : p7311.movT) + (p7311.movD == null ? "md" : p7311.movD) + (p7311.rotT == null ? "rt" : p7311.rotT) + (p7311.projection == null ? "" : "pj_" + p7311.projection) + (p7311.video == null ? "" : "v_" + p7311.video));
    var v6174 = vO170[v6173];
    if (!v6174) {
      v6174 = new THREE.BufferGeometry();
      var v6175 = config.playerHeight - config.headScale - config.legHeight;
      var v6176 = this.genColorCube(config.chestWidth, v6175, config.chestScale, [[p7311.shirtCol, 0.8, 1, 0.8, undefined, !!p7311.noBody], [p7311.waistCol, 0.2, 1.05]], 0, {
        us: p7310,
        uvScale: p7311.uvScale
      });
      this.moveMesh(v6176, 0, v6175 / 2, 0);
      v6174 = this.merge(v6174, v6176);
      if (!p7311.noHead) {
        var v6177 = this.genColorCube(config.headScale, config.headScale, config.headScale, [[p7311.hairCol, 0.2, 1, 0.6, undefined, !!p7311.noHair], [p7311.skinCol, 0.8]], 0, {
          us: p7310,
          uvScale: p7311.uvScale
        });
        this.moveMesh(v6177, 0, config.playerHeight - config.headScale / 2 - config.legHeight, 0);
        v6174 = this.merge(v6174, v6177);
      }
      v6174 = THREE.BufferGeometryUtils.mergeVertices(v6174);
      vO170[v6173] = v6174;
    }
    var v6178 = new THREE.Mesh(v6174, this.getMat(p7311.texSrc || "default", p7311));
    v6178.receiveShadow = true;
    v6178.castShadow = this.dynamicShadows;
    return v6178;
  };
  var vO171 = {};
  let v6179 = new THREE.Vector3();
  this.genArms = function (p7312, p7313, p7314, p7315) {
    p7315 = p7315 || {};
    var v6180 = (p7315.texSrc || "default") + p7312.name + "-" + p7315.shirtCol + "-" + p7315.sleeveCol + "-" + p7315.skinCol + "-" + p7314 + "-" + (p7313 || 0) + "-" + (p7315.rgb ? "rgb" : "") + (p7315.movT == null ? "mt" : p7315.movT) + (p7315.movD == null ? "md" : p7315.movD) + (p7315.rotT == null ? "rt" : p7315.rotT) + (p7315.leftHoldZ || 0) + (p7315.armS ? p7315.armS : "") + "-" + (p7315.noSleeve ? 1 : 0) + (p7315.leftHoldX || 0) + (p7315.leftHoldY || 0) + (p7315.rightHoldY || 0) + (p7315.noRightHand ? "nrh" : "rh") + (p7315.projection == null ? "" : "pj_" + p7315.projection) + (p7315.video == null ? "" : "v_" + p7315.video);
    var v6181 = vO171[v6180];
    if (!v6181) {
      v6181 = new THREE.BufferGeometry();
      var v6182 = (-config.chestWidth + config.armScale / 2 - config.armInset) * (p7314 ? p7312.holdW || 0.4 : 1);
      var vO172 = {};
      if (!p7313 || p7313 == 1) {
        v6181 = this.merge(v6181, this.genArm(v6182, config.armOff, p7312, true, p7315.shirtCol, p7315.sleeveCol, p7315.skinCol, p7314, p7315));
      }
      if (!p7313 || p7313 == 2) {
        v6181 = this.merge(v6181, this.genArm(-v6182, config.armOff, p7312, false, p7315.shirtCol, p7315.sleeveCol, p7315.skinCol, p7314, p7315));
      }
      if (!p7313 || p7313 == 1) {
        var v6184 = this.genArm(v6182, config.armOff, p7312, true, p7315.shirtCol, p7315.sleeveCol, p7315.skinCol, p7314, p7315);
        vO172.l = v6184.children[0].getWorldPosition(v6179);
        v6181 = this.merge(v6181, v6184);
      }
      if (!p7313 || p7313 == 2) {
        var v6184 = this.genArm(-v6182, config.armOff, p7312, false, p7315.shirtCol, p7315.sleeveCol, p7315.skinCol, p7314, p7315);
        vO172.r = v6184.children[0].getWorldPosition(v6179);
        v6181 = this.merge(v6181, v6184);
      }
      v6181 = THREE.BufferGeometryUtils.mergeVertices(v6181);
      v6181.tVecs = vO172;
      vO171[v6180] = v6181;
    }
    var v6185 = v6181.tVecs;
    v6181 = new THREE.Mesh(v6181, this.getMat(p7315.texSrc || "default", p7315));
    v6181.position.z += p7314 ? p7312.hDstOff || 0 : 0;
    v6181.receiveShadow = true;
    v6181.castShadow = !p7314 && this.highResShad;
    return {
      mesh: v6181,
      vecs: v6185
    };
  };
  this.genArm = function (p7316, p7317, p7318, p7319, p7320, p7321, p7322, p7323, p7324) {
    var v6186 = p7319 ? p7324.leftHoldY || p7318.leftHoldY : p7324.rightHoldY || p7318.rightHoldY;
    var v6187 = p7319 ? p7324.leftHoldZ || p7318.leftHoldZ : p7324.rightHoldZ || p7318.rightHoldZ;
    v6187 += p7323 ? p7318.hDstOff || 0 : 0;
    var v6188 = p7319 ? p7324.leftHoldX || p7318.leftHoldX || 0 : p7324.rightHoldX || p7318.rightHoldX || 0;
    var v6189 = config.armScale * (p7323 ? 0.68 : 1) * (p7324.armS || 1);
    var v6190 = Math.min(config.uArmLength + config.lArmLength - 0.01, UTILS.getD3D(p7316, p7317, 0, (p7318.xOff - v6188) * (p7319 && p7318.akimbo ? -1 : 1), p7318.yOff + v6186, p7318.zOff - v6187));
    var v6191 = UTILS.getAnglesSSS(v6190, config.uArmLength, config.lArmLength);
    var v6192 = Math.PI / 2;
    if (!p7323) {
      var v6193 = this.genColorCube(v6189, config.uArmLength, v6189, [[p7320, 1]], 0, {
        us: p7323,
        cyl: vThis47.roundArms,
        uvScale: p7324.uvScale
      });
      this.moveMesh(v6193, 0, -(config.uArmLength / 2 * Math.cos(v6192)), -(config.uArmLength / 2 * Math.sin(v6192)));
      this.rotateMesh(v6193, 0, v6192, 0);
      var v6194 = v6189 / 2;
      var v6195 = Math.sqrt(v6194 * v6194 + v6194 * v6194 - v6194 * 2 * v6194 * Math.cos(Math.PI + v6191[0] + Math.PI / 2));
      var v6196 = Math.sqrt(v6194 * v6194 - v6195 / 2 * (v6195 / 2)) * 2;
      var v6197 = this.genColorCube(v6189, v6195, v6196, [[p7320, 1]], 0, {
        us: p7323,
        cyl: vThis47.roundArms,
        uvScale: p7324.uvScale
      });
      this.moveMesh(v6197, 0, -(config.uArmLength * Math.cos(v6192)), -(config.uArmLength * Math.sin(v6192)));
      this.rotateMesh(v6197, 0, (v6192 + v6191[0]) / 2, 0);
    }
    var v6198 = this.genColorCube(v6189, config.lArmLength, v6189, [[p7320, 0.65, 1, 0.6], [p7321, 0.15, p7324.noSleeve ? 1 : 1.1], [p7322, 0.2, 1, 0.5, true, !p7319 && p7324.noRightHand]], 0, {
      us: p7323,
      noAmb: p7324.noSleeve,
      cyl: vThis47.roundArms,
      uvScale: p7324.uvScale
    });
    var v6199 = config.lArmLength / 2;
    this.moveMesh(v6198, 0, -config.uArmLength * Math.cos(v6192) - v6199 * Math.cos(v6191[0]), -config.uArmLength * Math.sin(v6192) - v6199 * Math.sin(v6191[0]));
    this.rotateMesh(v6198, 0, v6191[0], 0);
    var v6200 = new THREE.BufferGeometry();
    if (!p7323) {
      v6200 = this.merge(v6200, v6193);
      v6200 = this.merge(v6200, v6197);
    } else {
      var v6201 = this.genColorCube(v6189, 20, v6189, [[p7320, 1]], 0, {
        us: p7323,
        noAmb: true,
        cyl: vThis47.roundArms,
        uvScale: p7324.uvScale
      });
      this.moveMesh(v6201, 0, -config.uArmLength * Math.cos(v6192) - Math.cos(v6191[0]) * -10, -config.uArmLength * Math.sin(v6192) - Math.sin(v6191[0]) * -10);
      this.rotateMesh(v6201, 0, v6191[0], 0);
      v6200 = this.merge(v6200, v6201);
    }
    v6200 = this.merge(v6200, v6198);
    v6200 = new THREE.Mesh(v6200);
    v6200.add(this.genObj3D(0, 10, 0));
    this.moveMesh(v6200, p7316 - p7318.xOff, p7317 - p7318.yOff, -p7318.zOff);
    v6200.rotation.order = "YXZ";
    v6200.rotation.x = -v6191[1] - UTILS.getDir(0, p7317, p7318.zOff - v6187, p7318.yOff + v6186);
    v6200.rotation.y = UTILS.getDir(-p7316, 0, (p7319 && p7318.akimbo ? 1 : -1) * (p7318.xOff - v6188), p7318.zOff - v6187) - Math.PI / 2;
    return v6200;
  };
  this.addHelperC = function (p7325, p7326, p7327, p7328, p7329, p7330, p7331, p7332) {
    const v6202 = new THREE.BoxGeometry();
    const v6203 = new THREE.MeshBasicMaterial({
      color: p7332 || 16711680
    });
    const v6204 = new THREE.Mesh(v6202, v6203);
    vThis47.moveMesh(v6204, p7325, p7326 + p7329 / 2, p7327);
    v6204.rotation.y = p7331 || 0;
    v6204.scale.set(p7328 * 2, p7329, p7330 * 2);
    vThis47.scene.add(v6204);
  };
  this.fakeBufferMesh = function (p7333, p7334) {
    p7333.geometry = vThis47.updateGeoFromMesh(p7333, true);
    var v6205 = vThis47.meshGroup(p7333, p7334, true);
    if (v6205) {
      var vO173 = {
        data: v6205,
        _visible: true
      };
      Object.defineProperty(vO173, "visible", {
        get() {
          return this._visible || false;
        },
        set(p7335) {
          if (this._visible == !!p7335) {
            return this._visible;
          } else {
            this._visible = !!p7335;
            vThis47.bufferVisibility(vThis47.scene.getObjectByName(this.data.name), this.data, this._visible);
            return this._visible;
          }
        }
      });
      return vO173;
    }
  };
  this.addCube = function (p7336, p7337, p7338, p7339, p7340, p7341, p7342, p7343) {
    p7343 = p7343 || {};
    var v6206;
    if (!p7343.noShader && this.ShaderMesh.enabled && (!p7343.src || p7343.src.includes("default") || vO167[p7343.src])) {
      v6206 = this.ShaderMesh.addCube(p7336, p7337, p7338, p7339, p7340, p7341, p7343);
    } else {
      v6206 = new THREE.Mesh(vThis47.GEOS.generateCube(p7342, p7339, p7340, p7341, p7343));
      this.moveMesh(v6206, p7336, p7337, p7338);
      v6206.rotation.set(p7343.yR || 0, p7343.xR || 0, p7343.zR || 0);
      v6206.scale.set(p7339, p7340, p7341);
      if (this.noTex && !p7343.forceTex) {
        p7343.src = "default";
      }
      if (p7343.src && !p7343.noGroup) {
        var v6207 = vThis47.fakeBufferMesh(v6206, p7343);
        if (v6207) {
          return v6207;
        }
      } else {
        if (vThis47.staticRendering) {
          v6206 = v6206.toStatic();
        }
        this.add(v6206, p7343);
      }
    }
    return v6206;
  };
  this.createSpray = function (p7344) {
    var v6208 = new THREE.Mesh(new THREE.PlaneGeometry(1, 1));
    v6208.scale.set(9, 7.2, 1);
    v6208.material = vThis47.getMat("sprays/" + (p7344.id || 0), {
      local: p7344.local,
      transparent: true,
      alphaTest: 0.2,
      frames: p7344.frames,
      frameT: p7344.frameT,
      centerZ: true,
      side: 2,
      video: p7344.video,
      projection: p7344.projection
    });
    return v6208;
  };
  this.addSpinner = function (p7345, p7346, p7347, p7348, p7349, p7350) {
    p7350 = p7350 || {};
    p7348 = (p7348 || 0) * 2;
    var v6209 = new THREE.Mesh(vThis47.GEOS.generatePlane(p7348, p7348, p7350, p7345, p7346, p7347));
    v6209.material = new THREE.MeshBasicMaterial(p7350);
    this.moveMesh(v6209, p7345, p7346, p7347);
    v6209.rotateY(Math.PI / 2 - p7349);
    v6209.scale.set(p7348, p7348, 1);
    var vLN0997 = 0;
    var vLN0998 = 0;
    if (p7348 > p7348) {
      vLN0997 = 1;
      vLN0998 = p7348 / p7348;
    } else if (p7348 < p7348) {
      vLN0997 = p7348 / p7348;
      vLN0998 = 1;
    } else {
      vLN0997 = 1;
      vLN0998 = 1;
    }
    var v6210 = document.createElement("canvas");
    v6210.getContext("2d");
    var v6211 = Math.max(p7348 / 7.5 * 265, 768);
    v6211 = Math.min(v6211, 4096);
    v6210.width = v6211 * vLN0998;
    v6210.height = v6211 * vLN0997;
    v6209.canvas = v6210;
    v6209.material.map = new THREE.CanvasTexture(v6209.canvas);
    v6209.material.vertexColors = true;
    v6209.material.alphaTest = 0.1;
    this.scene.add(v6209);
    return v6209;
  };
  this.addPointLight = function (p7351, p7352, p7353, p7354) {
    if (!(vThis47.lighting < 2)) {
      p7354 = p7354 || {};
      var v6212 = new THREE.PointLight(p7354.colr || "#f2f8fc", p7354.intensity || 1, p7354.distance || 0, p7354.decay || 1);
      v6212.position.set(p7351, p7352, p7353);
      v6212.traverse(function (p7355) {
        p7355.layers.enable(1);
      });
      this.add(v6212, undefined, true);
    }
  };
  this.addDirectionalLight = function (p7356, p7357, p7358, p7359, p7360, p7361, p7362) {
    if (vThis47.lighting == 3) {
      p7362 = p7362 || {};
      var v6213 = new THREE.DirectionalLight(p7362.colr || "#f2f8fc", p7362.intensity || 1);
      v6213.position.set(p7356, p7357, p7358);
      v6213.target.position.set(p7359, p7360, p7361);
      v6213.traverse(function (p7363) {
        p7363.layers.enable(1);
      });
      this.add(v6213, undefined, true);
      this.add(v6213.target, undefined, true);
    }
  };
  this.addSpotLight = function (p7364, p7365, p7366, p7367, p7368, p7369, p7370) {
    if (!(vThis47.lighting < 2)) {
      p7370 = p7370 || {};
      var v6214 = new THREE.SpotLight(p7370.colr || "#f2f8fc", p7370.intensity || 1, p7370.distance || 0, UTILS.toRad(p7370.angle || 45), p7370.penumbra || 0, p7370.decay || 1);
      v6214.position.set(p7364, p7365, p7366);
      v6214.target.position.set(p7367, p7368, p7369);
      v6214.traverse(function (p7371) {
        p7371.layers.enable(1);
      });
      this.add(v6214, undefined, true);
      this.add(v6214.target, undefined, true);
    }
  };
  this.hasInitRectArea = false;
  this.addRectAreaLight = function (p7372, p7373, p7374, p7375, p7376, p7377, p7378, p7379, p7380) {
    if (vThis47.lighting == 3) {
      p7377 = p7377 || {};
      if (!this.hasInitRectArea) {
        this.hasInitRectArea = true;
        THREE.RectAreaLightUniformsLib.init();
      }
      p7375 = (p7375 || 0) * 2;
      p7376 = (p7376 || 0) * 2;
      var v6215 = new THREE.RectAreaLight(p7377.colr || "#f2f8fc", p7377.intensity || 1, p7375, p7376);
      this.moveMesh(v6215, p7372, p7373, p7374);
      v6215.rotateY(p7378 || 0);
      v6215.rotateX(p7379 || 0);
      v6215.rotateZ(p7380 || 0);
      v6215.traverse(function (p7381) {
        p7381.layers.enable(1);
      });
      this.add(v6215, undefined, true);
    }
  };
  this.addCone = function (p7382, p7383, p7384, p7385, p7386, p7387, p7388) {
    if (!this.noTex) {
      p7388 = p7388 || {};
      var v6216 = new THREE.Mesh(vThis47.GEOS.generateCone(p7386, p7388));
      v6216.scale.set(p7385 / 2, p7386, p7387 / 2);
      this.moveMesh(v6216, p7382, p7383, p7384);
      v6216.rotation.set(p7388.yR || 0, p7388.xR || 0, p7388.zR || 0);
      if (p7388.src && !p7388.noGroup) {
        var v6217 = vThis47.fakeBufferMesh(v6216, p7388);
        if (v6217) {
          return v6217;
        }
      } else {
        if (vThis47.staticRendering) {
          v6216 = v6216.toStatic();
        }
        this.add(v6216, p7388);
      }
      return v6216;
    }
  };
  this.addCylinder = function (p7389, p7390, p7391, p7392, p7393, p7394, p7395) {
    if (!this.noTex) {
      p7395 = p7395 || {};
      var v6218 = Math.min(p7392, p7394) / 2;
      var v6219 = new THREE.Mesh(vThis47.GEOS.generateCylinder(v6218, p7393, v6218, p7395));
      v6219.scale.set(v6218, p7393, v6218);
      this.moveMesh(v6219, p7389, p7390, p7391);
      v6219.rotation.set(p7395.yR || 0, p7395.xR || 0, p7395.zR || 0);
      if (p7395.rAnim) {
        this.movMeshes.push({
          mesh: v6219,
          tim: p7395.rAnim,
          mlt: p7395.rAnimM,
          axis: (p7395.rAnimA || "y").toUpperCase()
        });
      }
      if (p7395.src && !p7395.noGroup) {
        var v6220 = vThis47.fakeBufferMesh(v6219, p7395);
        if (v6220) {
          return v6220;
        }
      } else {
        if (vThis47.staticRendering && !p7395.spin) {
          v6219 = v6219.toStatic();
        }
        this.add(v6219, p7395);
      }
      return v6219;
    }
  };
  this.addSphere = function (p7396, p7397, p7398, p7399, p7400, p7401, p7402) {
    p7402 = p7402 || {};
    var v6221 = new THREE.Mesh(vThis47.GEOS.generateSphere(p7399, p7400, p7401, p7402));
    this.moveMesh(v6221, p7396, p7397 + p7400 / 2, p7398);
    v6221.rotation.set(p7402.yR || 0, p7402.xR || 0, p7402.zR || 0);
    v6221.scale.set(p7399 / 2, p7400 / 2, p7401 / 2);
    if (p7402.src && !p7402.noGroup) {
      var v6222 = vThis47.fakeBufferMesh(v6221, p7402);
      if (v6222) {
        return v6222;
      }
    } else {
      if (vThis47.staticRendering) {
        v6221 = v6221.toStatic();
      }
      this.add(v6221, p7402);
    }
    return v6221;
  };
  var vA323 = [];
  this.addSpray = function (p7403, p7404, p7405, p7406, p7407, p7408, p7409, p7410, p7411, p7412) {
    p7411 = p7411 || {};
    v6103 = null;
    for (var vLN0999 = 0; vLN0999 < vA323.length; ++vLN0999) {
      if (vA323[vLN0999].sid == p7403) {
        v6103 = vA323[vLN0999];
        break;
      }
    }
    var v6223 = false;
    if (!v6103) {
      v6223 = true;
      v6103 = {};
      v6103.sid = p7403;
      v6103.mesh = new THREE.Mesh(v6101);
      v6103.mesh.scale.set(config.sprayScale, config.sprayScale, 1);
      v6103.mesh.receiveShadow = true;
      this.add(v6103.mesh, undefined, true);
      vA323.push(v6103);
    }
    v6103.mesh.material = this.getMat("sprays/" + (p7411.id || 0), {
      local: p7411.local,
      depthWrite: false,
      opacity: p7411.opacity,
      transparent: true,
      frames: p7411.frames,
      frameT: p7411.frameT,
      movT: p7411.movT,
      movD: p7411.movD,
      rgb: p7411.rgb,
      rgbS: p7411.rgbS,
      rgbT: p7411.rgbT,
      sameGlow: p7411.sameGlow,
      glowText: p7411.glow || p7411.sameGlow,
      emissive: p7411.glow || p7411.sameGlow ? "#ffffff" : null,
      pulsT: p7411.pulsT,
      rAnim: p7411.rAnim,
      rAnimA: p7411.rAnimA,
      video: p7412 == null ? p7411.video : p7412.video,
      projection: p7412 == null ? p7411.projection : p7412.projection
    });
    this.moveMesh(v6103.mesh, p7405, p7406, p7407);
    v6103.mesh.rotation.y = UTILS.toRad(p7408);
    v6103.mesh.rotation.x = UTILS.toRad(p7409);
    v6103.mesh.rotation.z = UTILS.toRad(p7410);
  };
  this.clearSprays = function () {
    for (var vLN01000 = 0; vLN01000 < vA323.length; ++vLN01000) {
      if (vA323[vLN01000] && vA323[vLN01000].mesh.material.map) {
        vA323[vLN01000].mesh.material.map.dispose();
      }
      this.scene.remove(vA323[vLN01000].mesh);
    }
    vA323.length = 0;
  };
  this.addPlane = function (p7413, p7414, p7415, p7416, p7417, p7418, p7419, p7420, p7421) {
    p7418 = p7418 || {};
    p7418.premultipliedAlpha = true;
    var v6224;
    if (!p7418.noShader && this.ShaderMesh.enabled && (!p7418.src || p7418.src.includes("default") || vO167[p7418.src])) {
      v6224 = this.ShaderMesh.addPlane(p7413, p7414, p7415, p7416, p7417, p7418, p7419, p7420, p7421);
    } else {
      p7416 = (p7416 || 0) * 2;
      p7417 = (p7417 || 0) * 2;
      v6224 = new THREE.Mesh(vThis47.GEOS.generatePlane(p7417, p7416, p7418, p7413, p7414, p7415));
      if (p7418.euler) {
        v6224.rotation.order = p7418.euler;
      }
      this.moveMesh(v6224, p7413, p7414, p7415);
      v6224.rotateY(p7419 || 0);
      v6224.rotateX((p7420 || 0) - Math.PI / 2);
      v6224.rotateZ(p7421 || 0);
      v6224.scale.set(p7416, p7417, 1);
      if (this.noTex) {
        p7418.src = "default";
      }
      if (p7418.dontAdd) {
        if (p7418.src) {
          v6224.material = this.getMat(p7418.src, p7418);
        }
      } else if (p7418.src && !p7418.noGroup) {
        var v6225 = vThis47.fakeBufferMesh(v6224, p7418);
        if (v6225) {
          return v6225;
        }
      } else {
        if (vThis47.staticRendering) {
          v6224 = v6224.toStatic();
        }
        this.add(v6224, p7418);
      }
    }
    return v6224;
  };
  this.addFixedPlane = function (p7422, p7423, p7424, p7425, p7426, p7427, p7428, p7429, p7430) {
    p7427 = p7427 || {};
    p7427.premultipliedAlpha = true;
    var v6226;
    if (!p7427.noShader && this.ShaderMesh.enabled && (!p7427.src || p7427.src.includes("default") || vO167[p7427.src])) {
      v6226 = this.ShaderMesh.addPlane(p7422, p7423, p7424, p7425, p7426, p7427, p7428, p7429, p7430);
    } else {
      p7425 = (p7425 || 0) * 2;
      p7426 = (p7426 || 0) * 2;
      v6226 = new THREE.Mesh(vThis47.GEOS.generatePlane(p7426, p7425, p7427, p7422, p7423, p7424));
      if (p7427.euler) {
        v6226.rotation.order = p7427.euler;
      }
      this.moveMesh(v6226, p7422, p7423, p7424);
      this.similateRot(v6226.quaternion, p7428, p7429, p7430);
      v6226.scale.set(p7425, p7426, 1);
      if (this.noTex) {
        p7427.src = "default";
      }
      if (p7427.dontAdd) {
        if (p7427.src) {
          v6226.material = this.getMat(p7427.src, p7427);
        }
      } else if (p7427.src && !p7427.noGroup) {
        var v6227 = vThis47.fakeBufferMesh(v6226, p7427);
        if (v6227) {
          return v6227;
        }
      } else {
        if (vThis47.staticRendering) {
          v6226 = v6226.toStatic();
        }
        this.add(v6226, p7427);
      }
    }
    return v6226;
  };
  this.addSprite = function (p7431, p7432, p7433, p7434, p7435, p7436) {
    p7436 = p7436 || {};
    p7436.premultipliedAlpha = true;
    p7434 = (p7434 || 0) * 2;
    p7435 = (p7435 || 0) * 2;
    var v6228 = new THREE.Sprite();
    this.moveMesh(v6228, p7431, p7432, p7433);
    v6228.scale.set(p7434, p7435, 1);
    if (this.noTex) {
      p7436.src = "default";
    }
    this.add(v6228, p7436);
    return v6228;
  };
  var v6229 = new THREE.Object3D();
  var v6230 = new THREE.Object3D();
  var v6231 = new THREE.Euler();
  v6230.add(v6229);
  this.similateRot = function (p7437, p7438, p7439, p7440) {
    v6229.rotation.set(0, 0, 0);
    v6229.position.set(0, 0, 0);
    v6229.rotateX(-Math.PI / 2);
    v6230.rotation.set(0, 0, 0);
    v6230.position.set(0, 0, 0);
    v6230.rotateX(p7438 || 0);
    v6230.rotateY(p7439 || 0);
    v6230.rotateZ(p7440 || 0);
    v6229.getWorldQuaternion(p7437);
    return v6231.setFromQuaternion(p7437);
  };
  this.similatePosRot = function (p7441, p7442, p7443, p7444, p7445) {
    v6229.rotation.set(0, 0, 0);
    v6229.position.set(0, p7445, 0);
    v6230.position.set(p7442, p7443, p7444);
    v6230.rotation.set(0, 0, 0);
    v6230.rotateX(p7441.rotation.x || 0);
    v6230.rotateY(p7441.rotation.y || 0);
    v6230.rotateZ(p7441.rotation.z || 0);
    v6229.getWorldQuaternion(p7441.quaternion);
    v6229.getWorldPosition(p7441.position);
  };
  this.addRamp = function (p7446, p7447, p7448, p7449, p7450, p7451, p7452, p7453, p7454) {
    p7453 = p7453 || {};
    var v6232;
    if (p7453.enclose) {
      v6232 = new THREE.Mesh(vThis47.GEOS.generateRamps(p7449, p7450, p7451, p7453));
      v6232.scale.set(p7453.rot ? p7453.l : p7453.w, p7453.h, p7453.rot ? p7453.w : p7453.l);
      v6232.rotateY(Math.PI - p7452);
      v6232.position.set(p7446, p7447 + p7450 / 2, p7448);
    } else {
      v6232 = new THREE.Mesh(vThis47.GEOS.generatePlane(p7451 * 2, p7449, p7453));
      p7451 *= 2;
      var v6233 = Math.sqrt(p7450 * p7450 + p7451 * p7451);
      this.moveMesh(v6232, p7446, p7447 + p7450 / 2, p7448);
      v6232.scale.set(p7449, v6233, 2);
      v6232.rotateY(-(Math.PI / 2) - p7452);
      v6232.rotateX(Math.asin(p7450 / v6233) - Math.PI / 2);
      v6232.rotateZ(p7454 || 0);
    }
    if (this.noTex) {
      p7453.src = "default";
    }
    if (p7453.src && !p7453.noGroup) {
      var v6234 = vThis47.fakeBufferMesh(v6232, p7453);
      if (v6234) {
        return v6234;
      }
    } else {
      if (vThis47.staticRendering) {
        v6232 = v6232.toStatic();
      }
      this.add(v6232, p7453);
    }
    return v6232;
  };
  var vA324 = [];
  var vA325 = [];
  var vA326 = [];
  var vA327 = [];
  this.loadMesh = function (p7455, p7456, p7457, p7458, p7459, p7460, p7461, p7462, p7463) {
    p7455 = p7455 || {};
    if (p7455.video == 2) {
      p7455.mat = THREE.MeshBasicMaterial;
    }
    if (!vThis47.tmpVector3) {
      vThis47.tmpVector3 = new THREE.Vector3();
    }
    if (p7455.useWireframe) {
      p7455.mat = THREE.MeshBasicMaterial;
    }
    if (p7455.isMdl && p7462) {
      delete p7455.isMdl;
    }
    p7455.fileExt = p7455.fileExt || "obj";
    var v6235 = this.getMat(p7455.src, p7455);
    var v6236 = (p7455.texVar == null ? p7455.src : p7455.texSrc || p7455.src) + p7455.fileExt + (p7455.rAnim == null ? "" : "ra" + p7455.rAnim) + (p7455.rAnimA == null ? "" : "raa" + p7455.rAnimA) + (p7455.rAnimT == null ? "" : "rt" + p7455.rAnimT) + (p7455.rAnimM == null ? "" : "rm" + p7455.rAnimM) + (p7455.canDest ? "cd" : "") + (p7455.noFog == null ? "" : "nf") + (p7455.noTex == null ? "" : "nt");
    var v6237 = vA325[v6236] || vA324[v6236];
    if (!v6237) {
      if (v6235 && v6235.wireframe && p7455.useWireframe) {
        v6235.wireframe = false;
      }
      v6237 = new THREE.BufferGeometry();
      v6237.loading = true;
      vA324[v6236] = v6237;
      var v6238 = null;
      if (p7455.asset) {
        v6238 = function (p7464) {
          vThis47.updateProgress((p7464.loaded / p7464.total * 100).round(0));
        };
      }
      (p7455.fileExt == "gltf" ? v6099 : p7455.fileExt == "fbx" ? v6100 : v6098).load(p7455.asset ? UTILS.userAssetsUrl(p7455.src + "." + p7455.fileExt) : UTILS.assetsUrl("/models/" + p7455.src + "." + p7455.fileExt, false, p7455.localM), function (p7465) {
        delete v6237.loading;
        if (p7465.scene) {
          p7465 = p7465.scene;
        }
        var v6239 = p7465.children[0].geometry;
        if (p7465.children.length > 1) {
          var vA329 = [];
          for (var vLN01004 = 0; vLN01004 < p7465.children.length; ++vLN01004) {
            if (p7465.children[vLN01004]) {
              if (p7465.children[vLN01004].type != "Object3D") {
                vA329.push(vThis47.updateGeoFromMesh(p7465.children[vLN01004]));
              } else {
                for (var vLN01002 = 0; vLN01002 < p7465.children[vLN01004].children.length; ++vLN01002) {
                  if (p7465.children[vLN01004].children[vLN01002] && p7465.children[vLN01004].children[vLN01002].geometry && p7465.children[vLN01004].children[vLN01002].type != "Object3D") {
                    vA329.push(vThis47.updateGeoFromMesh(p7465.children[vLN01004].children[vLN01002]));
                  }
                }
              }
            }
          }
          v6239 = vThis47.GEOS.mergeGeometries(vA329);
        } else if (p7465.children[0].type == "Object3D" && !p7465.children[0].geometry && p7465.children[0].children) {
          var vA329 = [];
          for (var vLN01004 = 0; vLN01004 < p7465.children[0].children.length; ++vLN01004) {
            if (p7465.children[0].children[vLN01004] && p7465.children[0].children[vLN01004].geometry) {
              vA329.push(vThis47.updateGeoFromMesh(p7465.children[0].children[vLN01004]));
            }
          }
          v6239 = vThis47.GEOS.mergeGeometries(vA329);
        } else {
          vThis47.GEOS.fixBufferGeometry(v6239);
        }
        if (p7455.asset && !p7462) {
          v6239 = THREE.BufferGeometryUtils.mergeVertices(v6239);
        }
        if (p7455.asset || p7455.offsetH != null) {
          v6239.computeBoundingBox();
          var v6242 = v6239.boundingBox.getCenter(vThis47.tmpVector3);
          v6239.translate(0, -v6242.y, 0);
        }
        v6237.copy(v6239);
        if (p7455.useWireframe && v6235) {
          v6235.wireframe = true;
          v6235.needsUpdate = true;
        }
        if (p7455.uv2 && !p7462) {
          v6237.setAttribute("uv2", new THREE.BufferAttribute(v6237.attributes.uv.array, 2));
        }
        if (p7462) {
          if (vA327[v6236] && vA327[v6236].length) {
            var vA330 = [];
            for (var vLN01004 = 0; vLN01004 < vA327[v6236].length; ++vLN01004) {
              vA330.push(vThis47.updateGeoFromMesh(vA327[v6236][vLN01004]));
            }
            vA330 = vThis47.GEOS.mergeGeometries(vA330);
            if (p7455.uv2) {
              vA330.setAttribute("uv2", new THREE.BufferAttribute(vA330.attributes.uv.array, 2));
            }
            var v6241 = new THREE.Mesh(vA330, v6235);
            v6241.isModel = true;
            vThis47.add(v6241, p7455);
          }
          if (vA327[v6236]) {
            vA327[v6236].length = 0;
            vA327[v6236].loaded = true;
          }
        }
        if (p7455.centerZ) {
          v6237.computeBoundingBox();
          var v6242 = v6237.boundingBox.getCenter(vThis47.tmpVector3);
          p7461.translateZ(v6242.x * p7460);
        }
        if (p7463 && typeof p7463 == "function") {
          p7463();
        }
      }, v6238);
    } else {
      if (p7455.centerZ) {
        v6237.computeBoundingBox();
        var v6243 = v6237.boundingBox.getCenter(vThis47.tmpVector3);
        p7461.translateZ(v6243.x * p7460);
      }
      if (p7455.useWireframe && v6235 && !v6237.loading) {
        v6235.wireframe = true;
        v6235.needsUpdate = true;
      }
      if (p7463 && typeof p7463 == "function") {
        p7463();
      }
    }
    var v6244 = new THREE.Mesh(v6237, v6235);
    v6244.receiveShadow = !p7455.noShadow;
    v6244.castShadow = p7455.shadows;
    if (typeof p7459 == "object") {
      v6244.rotation.x = v6244.xR = p7459[0] || 0;
      v6244.rotation.y = v6244.yR = p7459[1] || 0;
      v6244.rotation.z = v6244.zR = p7459[2] || 0;
    } else {
      v6244.rotation.y = p7459 || 0;
    }
    v6244.isModel = true;
    v6244.xP = p7456;
    v6244.yP = p7457;
    v6244.zP = p7458;
    vThis47.moveMesh(v6244, p7456, p7457, p7458);
    vThis47.scaleMesh(v6244, p7460 || 1, p7460 || 1, p7460 || 1);
    if (p7455.outlineMesh != null) {
      v6244.outlineMesh = new THREE.Mesh(v6244.geometry, vA319[p7455.outlineMesh || 0]);
      v6244.outlineMesh.position = v6244.position;
      v6244.outlineMesh.scale.multiplyScalar(p7455.outlineScale || 1.025);
      v6244.add(v6244.outlineMesh);
    }
    if (p7455.asset || p7455.offsetH != null) {
      vThis47.similatePosRot(v6244, p7456, p7457, p7458, p7455.offsetH || 0);
    }
    f1115(v6244, p7455);
    if (p7462) {
      if (vA327[v6236]) {
        if (vA327[v6236].loaded) {
          this.meshGroup(v6244, p7455);
        } else {
          vA327[v6236].push(v6244);
        }
      } else {
        vA327[v6236] = [v6244];
      }
    } else {
      p7461.add(v6244);
    }
    if (p7455.forceRender) {
      v6244.frustumCulled = false;
      v6244.renderOrder = Infinity;
    }
    return v6244;
  };
  this.updateGeoFromMesh = function (p7466, p7467) {
    p7466.updateMatrix();
    var v6245 = new THREE.BufferGeometry().copy(p7466.geometry);
    v6245.applyMatrix4(p7466.matrix);
    if (p7467 && v6245.index) {
      v6245 = v6245.toNonIndexed();
    }
    return v6245;
  };
  var vA331 = [];
  this.loadAnimMesh = function (p7468, p7469, p7470, p7471, p7472, p7473, p7474, p7475, p7476) {
    p7468 = p7468 || {};
    p7468.fileExt = p7468.fileExt || "gltf";
    var v6246 = null;
    if (p7468.asset) {
      v6246 = function (p7477) {
        vThis47.updateProgress((p7477.loaded / p7477.total * 100).round(0));
      };
    }
    var v6247 = new THREE.Mesh();
    v6247.isModel = true;
    v6247.receiveShadow = !p7468.noShadow;
    v6247.castShadow = p7468.shadows;
    if (typeof p7472 == "object") {
      v6247.rotation.x = v6247.xR = p7472[0] || 0;
      v6247.rotation.y = v6247.yR = p7472[1] || 0;
      v6247.rotation.z = v6247.zR = p7472[2] || 0;
    } else {
      v6247.rotation.y = p7472 || 0;
    }
    v6247.xP = p7469;
    v6247.yP = p7470;
    v6247.zP = p7471;
    vThis47.moveMesh(v6247, p7469, p7470, p7471);
    vThis47.scaleMesh(v6247, p7473 || 1, p7473 || 1, p7473 || 1);
    if (p7468.forceRender) {
      v6247.frustumCulled = false;
      v6247.renderOrder = Infinity;
    }
    if (!vA331[p7468.src + p7468.fileExt]) {
      (p7468.fileExt == "gltf" || p7468.fileExt == "glb" ? v6099 : p7468.fileExt == "fbx" ? v6100 : v6098).load(p7468.asset ? UTILS.userAssetsUrl(p7468.src + "." + p7468.fileExt) : UTILS.assetsUrl("/models/" + p7468.src + "." + p7468.fileExt, false, p7468.localM), function (p7478) {
        vA331[p7468.src + p7468.fileExt] = p7478;
        var v6248 = null;
        v6248 = p7468.fileExt == "gltf" || p7468.fileExt == "glb" ? vF46(p7478) : p7468.fileExt == "fbx" ? vF47(p7478) : p7478;
        var v6249 = p7468.fileExt == "fbx" ? v6248 : v6248.scene || v6248.scenes[0];
        f1117(v6247, p7468, v6248, v6249);
        p7474.add(v6247);
        if (p7476 && typeof p7476 == "function") {
          p7476();
        }
      }, v6246);
    } else {
      var v6250 = vA331[p7468.src + p7468.fileExt];
      var v6251 = null;
      v6251 = p7468.fileExt == "gltf" || p7468.fileExt == "glb" ? vF46(v6250) : p7468.fileExt == "fbx" ? vF47(v6250) : v6250;
      var v6252 = p7468.fileExt == "fbx" ? v6251 : v6251.scene || v6251.scenes[0];
      f1117(v6247, p7468, v6251, v6252);
      p7474.add(v6247);
      if (p7476 && typeof p7476 == "function") {
        p7476();
      }
    }
    return v6247;
  };
  const vA332 = ["map", "emissiveMap", "metalnessMap", "roughnessMap", "normalMap", "aoMap", "clearcoatMap", "clearcoatRoughnessMap", "clearcoatNormalMap", "clearcoatNormalMap", "iridescenceMap", "iridescenceThicknessMap", "sheenColorMap", "sheenRoughnessMap", "transmissionMap", "thicknessMap", "specularIntensityMap", "specularColorMap"];
  const vF46 = p7479 => {
    const vO174 = {
      nodes: p7479.nodes,
      animations: p7479.animations,
      scene: p7479.scene.clone(true)
    };
    const vO175 = {};
    p7479.scene.traverse(p7480 => {
      if (p7480.isSkinnedMesh) {
        vO175[p7480.name] = p7480;
      }
    });
    const vO176 = {};
    const vO177 = {};
    vO174.scene.traverse(p7481 => {
      if (p7481.isBone) {
        vO176[p7481.name] = p7481;
      }
      if (p7481.isSkinnedMesh) {
        vO177[p7481.name] = p7481;
      }
    });
    for (let v6253 in vO175) {
      const v6254 = vO175[v6253];
      const v6255 = v6254.skeleton;
      const v6256 = vO177[v6253];
      const vA333 = [];
      for (let vLN01005 = 0; vLN01005 < v6255.bones.length; ++vLN01005) {
        const v6257 = vO176[v6255.bones[vLN01005].name];
        vA333.push(v6257);
      }
      v6256.bind(new THREE.Skeleton(vA333, v6255.boneInverses), v6256.matrixWorld);
    }
    return vO174;
  };
  const vF47 = p7482 => {
    const v6258 = p7482.clone(true);
    v6258.animations = p7482.animations;
    const vO178 = {};
    p7482.traverse(p7483 => {
      if (p7483.isSkinnedMesh) {
        vO178[p7483.name] = p7483;
      }
    });
    const vO179 = {};
    const vO180 = {};
    v6258.traverse(p7484 => {
      if (p7484.isBone) {
        vO179[p7484.name] = p7484;
      }
      if (p7484.isSkinnedMesh) {
        vO180[p7484.name] = p7484;
      }
    });
    for (let v6259 in vO178) {
      const v6260 = vO178[v6259];
      const v6261 = v6260.skeleton;
      const v6262 = vO180[v6259];
      const vA334 = [];
      for (let vLN01006 = 0; vLN01006 < v6261.bones.length; ++vLN01006) {
        const v6263 = vO179[v6261.bones[vLN01006].name];
        vA334.push(v6263);
      }
      v6262.bind(new THREE.Skeleton(vA334, v6261.boneInverses), v6262.matrixWorld);
    }
    return v6258;
  };
  this.traverseMats = function (p7485, p7486) {
    if (Array.isArray(p7485.material)) {
      p7485.material.forEach(p7486);
    } else {
      p7486(p7485.material);
    }
  };
  this.loadGeo = function (p7487, p7488) {
    p7487 = p7487 || {};
    p7487.fileExt = p7487.fileExt || "obj";
    var v6264 = vA324[p7487.src + p7487.fileExt];
    if (v6264) {
      return p7488(p7487, v6264);
    } else {
      v6264 = new THREE.BufferGeometry();
      vA324[p7487.src + p7487.fileExt] = v6264;
      (p7487.fileExt == "gltf" ? v6099 : v6098).load(p7487.asset ? UTILS.userAssetsUrl(p7487.src + "." + p7487.fileExt) : UTILS.assetsUrl("/models/" + p7487.src + "." + p7487.fileExt, false, p7487.localM), function (p7489) {
        if (p7489.scene) {
          p7489 = p7489.scene;
        }
        var v6265 = p7489.children[0].geometry;
        if (p7489.children.length > 1) {
          var vA337 = [];
          for (var vLN01009 = 0; vLN01009 < p7489.children.length; ++vLN01009) {
            if (p7489.children[vLN01009]) {
              if (p7489.children[vLN01009].type != "Object3D") {
                vA337.push(vThis47.updateGeoFromMesh(p7489.children[vLN01009]));
              } else {
                var vA336 = [];
                for (var vLN01008 = 0; vLN01008 < p7489.children[vLN01009].children.length; ++vLN01008) {
                  if (p7489.children[vLN01009].children[vLN01008] && p7489.children[vLN01009].children[vLN01008].geometry && p7489.children[vLN01009].children[vLN01008].type != "Object3D") {
                    vA336.push(vThis47.updateGeoFromMesh(p7489.children[vLN01009].children[vLN01008]));
                  }
                }
                vA337.push(vThis47.GEOS.mergeGeometries(vA336));
              }
            }
          }
          v6265 = vThis47.GEOS.mergeGeometries(vA337);
        } else if (p7489.children[0].type == "Object3D" && !p7489.children[0].geometry && p7489.children[0].children) {
          var vA337 = [];
          for (var vLN01009 = 0; vLN01009 < p7489.children[0].children.length; ++vLN01009) {
            if (p7489.children[0].children[vLN01009] && p7489.children[0].children[vLN01009].geometry) {
              vA337.push(vThis47.updateGeoFromMesh(p7489.children[0].children[vLN01009]));
            }
          }
          v6265 = vThis47.GEOS.mergeGeometries(vA337);
        }
        v6265 = THREE.BufferGeometryUtils.mergeVertices(v6265);
        v6264.copy(v6265);
        p7488(p7487, v6264);
      });
      return;
    }
  };
  this.assetProgress = null;
  this.updateProgress = function (p7490) {
    if (!p7240) {
      vThis47.assetProgress = "Loading " + p7490 + "%";
      if (p7490 >= 100) {
        vThis47.assetProgress = null;
      }
    }
  };
  this.loadSprite = function (p7491, p7492) {
    var v6266 = this.getMat(p7491.src, p7491);
    var v6267 = new THREE.Sprite(v6266);
    v6267.yP = 0;
    v6267.xP = 0;
    v6267.zP = 0;
    v6267.position.set(0, config.playerHeight / 2, 0);
    v6267.scale.set(config.playerHeight, config.playerHeight, 1);
    p7492.add(v6267);
    return v6267;
  };
  this.clearPendingMeshes = function () {
    for (var v6268 in vA327) {
      if (vA327.hasOwnProperty(v6268) && vA327[v6268]) {
        vA327[v6268].length = 0;
      }
    }
  };
  this.updateMesh = function (p7493, p7494, p7495) {
    p7495 = p7495 || "obj";
    if (!p7493.toLowerCase().startsWith("event_0")) {
      if (p7495 == "obj") {
        var v6269 = v6098.parse(p7494);
        if (v6269 && v6269.children && v6269.children[0] && v6269.children[0].geometry) {
          var v6270 = new THREE.BufferGeometry();
          vA324[p7493 + p7495] = v6270;
          vA325[p7493 + p7495] = v6270;
          v6270.copy(v6269.children[0].geometry);
          v6270.needsUpdate = true;
        }
      } else if (p7495 == "gltf" || p7495 == "glb") {
        v6099.parse(p7494, "", function (p7496) {
          vA331[p7493 + p7495] = p7496;
          p7496.needsUpdate = true;
        });
      } else if (p7495 == "fbx") {
        v6100.parse(p7494, "", function (p7497) {
          vA331[p7493 + p7495] = p7497;
          p7497.needsUpdate = true;
        });
      }
    }
  };
  this.merge = function (p7498, p7499) {
    p7499.geometry = vThis47.updateGeoFromMesh(p7499);
    return vThis47.GEOS.mergeGeometries([p7498, p7499.geometry]);
  };
  this.genObj3D = function (p7500, p7501, p7502) {
    var v6271 = new THREE.Object3D();
    this.moveMesh(v6271, p7500 || 0, p7501 || 0, p7502 || 0);
    return v6271;
  };
  this.bufferVisibility = function (p7503, p7504, p7505) {
    if (p7503.geometry.attributes && p7503.geometry.attributes.position && p7503.geometry.attributes && p7503.geometry.attributes.uv) {
      var v6272 = p7503.geometry.attributes.position.array;
      var v6273 = p7503.geometry.attributes.uv.array;
      var v6274 = p7503.prevPositions[p7504.startP] || [];
      var v6275 = p7503.prevUvs[p7504.startU] || [];
      if (!p7505) {
        v6275.length = 0;
        for (var v6279 = p7504.startU; v6279 < p7504.endU; v6279++) {
          v6275.push(v6273[v6279]);
          v6273[v6279] = 0;
        }
        v6274.length = 0;
        for (var v6279 = p7504.startP; v6279 < p7504.endP; v6279++) {
          v6274.push(v6272[v6279]);
          v6272[v6279] = 0;
        }
      } else {
        for (var v6279 = p7504.startU; v6279 < p7504.endU; v6279++) {
          v6273[v6279] = v6275[v6279 - p7504.startU];
        }
        v6275.length = 0;
        for (var v6279 = p7504.startP; v6279 < p7504.endP; v6279++) {
          v6272[v6279] = v6274[v6279 - p7504.startP];
        }
        v6274.length = 0;
      }
      p7503.prevPositions[p7504.startP] = v6274;
      p7503.prevUvs[p7504.startU] = v6275;
      p7503.geometry.attributes.position.needsUpdate = true;
      p7503.geometry.attributes.uv.needsUpdate = true;
      p7503.geometry.computeBoundingBox();
      p7503.geometry.computeBoundingSphere();
    }
  };
  this.meshGroup = function (p7506, p7507, p7508) {
    if (p7508 && p7507.colr) {
      delete p7507.colr;
    }
    var v6280 = UTILS.getMeshGroupIndex(p7507, this.noTex);
    if (!vO166[v6280]) {
      vO166[v6280] = {};
      vO166[v6280].data = p7507;
      vO166[v6280].isModel = p7506.isModel;
      vO166[v6280].indx = v6280;
      vO166[v6280].list = [];
      vO166[v6280].currPOffset = 0;
      vO166[v6280].currUOffset = 0;
      vO166[v6280].name = UTILS.randomString(32);
    }
    p7506.updateMatrix();
    var v6281 = vO166[v6280].currPOffset;
    var v6282 = vO166[v6280].currUOffset;
    var v6283 = p7506.geometry.attributes && p7506.geometry.attributes.position ? p7506.geometry.attributes.position.array.length : 0;
    var v6284 = p7506.geometry.attributes && p7506.geometry.attributes.uv ? p7506.geometry.attributes.uv.array.length : 0;
    vO166[v6280].currPOffset += v6283;
    vO166[v6280].currUOffset += v6284;
    vO166[v6280].list.push(p7506.geometry);
    return {
      startP: v6281,
      startU: v6282,
      endP: v6281 + v6283,
      endU: v6282 + v6284,
      name: vO166[v6280].name
    };
  };
  this.addMeshGroups = function () {
    for (var v6285 in vO166) {
      if (vO166.hasOwnProperty(v6285)) {
        var v6286 = vThis47.GEOS.mergeGeometries(vO166[v6285].list);
        var v6287 = new THREE.Mesh(v6286);
        if (vThis47.staticRendering) {
          v6287 = v6287.toStatic();
        }
        v6287.groupSrc = vO166[v6285].data.src;
        v6287.visible = !vO181[v6287.groupSrc];
        v6287.isModel = vO166[v6285].isModel;
        v6287.indx = vO166[v6285].indx;
        v6287.prevPositions = [];
        v6287.prevUvs = [];
        v6287.name = vO166[v6285].name;
        this.add(v6287, vO166[v6285].data);
      }
    }
    vO166 = {};
  };
  this.finalizeInstanceGroups = function () {
    if (this.ShaderMesh.enabled) {
      this.ShaderMesh.finalize();
    }
  };
  this.clearInstances = function () {
    this.ShaderMesh.reset();
  };
  var vO181 = {};
  this.toggleMeshGroup = function (p7509, p7510) {
    vO181[p7509] = !p7510;
    if (this.scene) {
      this.scene.traverse(function (p7511) {
        if (p7511 && (p7511.groupSrc == p7509 || p7511.dSrc == p7509)) {
          p7511.visible = p7510;
        }
      });
    }
  };
  this.add = function (p7512, p7513) {
    if (p7513) {
      p7512.castShadow = p7513.shadows;
      p7512.receiveShadow = p7513.shadows || p7513.shadowsR;
      p7512.material = p7513.skipMat ? new THREE.StrippedLambertMaterial(p7513) : this.getMat(this.noTex && !p7513.forceTex ? "default" : p7513.src, p7513);
      p7512.dSrc = p7513.src;
      p7512.indx = UTILS.getMeshGroupIndex(p7513, this.noTex);
      if (p7513.noGroup && p7513.renderVisD) {
        this.rendDisObjs.push({
          dis: p7513.renderVisD,
          ms: p7512
        });
      }
    }
    this.scene.add(p7512);
    this.updateShadowMap();
  };
  var vA338 = [];
  this.remove = function (p7514) {
    if (p7514 && (vA338.length = 0, p7514.traverse(p7515 => {
      if (p7515 && p7515.isMesh) {
        vA338.push(p7515.uuid);
      }
    }), vA338.length)) {
      for (var v6288 = vA326.length - 1; v6288 >= 0; --v6288) {
        if (vA326[v6288] && vA338.includes(vA326[v6288].uuid)) {
          vA326.splice(v6288, 1);
        }
      }
    }
    this.scene.remove(p7514);
  };
  this.moveMesh = function (p7516, p7517, p7518, p7519) {
    if (p7516) {
      if (p7517 != null) {
        p7516.position.x = p7517;
      }
      if (p7518 != null) {
        p7516.position.y = p7518;
      }
      if (p7519 != null) {
        p7516.position.z = p7519;
      }
    }
  };
  this.scaleMesh = function (p7520, p7521, p7522, p7523) {
    p7520.scale.set(p7521, p7522, p7523);
  };
  this.rotateMesh = function (p7524, p7525, p7526, p7527) {
    if (p7524) {
      if (p7525 || p7525 == 0) {
        p7524.rotation.y = p7525;
      }
      if (p7526 || p7526 == 0) {
        p7524.rotation.x = p7526;
      }
      if (p7527 || p7527 == 0) {
        p7524.rotation.z = p7527;
      }
    }
  };
  this.clearGeos = function () {
    vThis47.GEOS.reset();
    for (var v6289 in vA324) {
      if (vA324[v6289].dispose) {
        vA324[v6289].dispose();
      }
    }
    vA324 = [];
    vA327 = [];
  };
  this.resetNormal = function () {
    this.liquids.length = 0;
    this.rendDisObjs.length = 0;
    this.rendDisCnt = 0;
  };
  this.reset = function (p7528) {
    try {
      for (var v6292 in vO162) {
        if (vO162[v6292].dispose) {
          vO162[v6292].dispose();
        }
      }
    } catch (e67) {}
    for (var v6292 in vO163) {
      if (vO163[v6292].dispose) {
        vO163[v6292].dispose();
      }
    }
    if (!p7528) {
      for (var v6292 in vA325) {
        if (vA325[v6292].dispose) {
          vA325[v6292].dispose();
        }
      }
    }
    this.clearGeos();
    pendingGIs = {};
    vO166 = {};
    vO162 = {};
    vO163 = {};
    if (!p7528) {
      vA325 = [];
    }
    if (!p7528) {
      vO164 = {};
    }
    vA331 = [];
    vA326.length = 0;
    this.frameMats.length = 0;
    this.rgbMats.length = 0;
    this.pulsMats.length = 0;
    this.pulsVal = 0;
    this.liquidVal = 0;
    this.movTextures.length = 0;
    this.rotTextures.length = 0;
    this.movMeshes.length = 0;
    this.swayX = this.swayY = 0;
    this.resetNormal();
  };
  this.disable = function () {
    this.reset();
    this.dontRender = true;
  };
  this.updateEnvironment = function (p7529, p7530, p7531) {
    if (this.lastEnvId != p7530) {
      var v6293 = p7530 == -1 ? {
        data: v6089
      } : p7530 == -2 ? {
        data: p7531
      } : p7529.map.manager.envZones[p7530];
      if (v6293) {
        v6293.data.shadLength = v6089.shadLength;
        v6293.data.shadWidth = v6089.shadWidth;
        var v6294 = p7530 == -1 ? v6090 : p7529.mode;
        this.init(v6293.data, v6294, true);
        this.updateShadowMap();
        var v6295;
        var v6296 = p7529.mode.ambInd || v6293.data.ambInd || 1;
        if (v6293.data.ambIndC) {
          v6296 = v6293.data.ambIndC;
          v6295 = true;
        }
        window.changeAmbient(v6296, v6295);
        this.lastEnvId = p7530;
        this.updateLightMap(v6293.data);
      }
    }
  };
  this.traverseBones = function (p7532, p7533) {
    if (!p7532) {
      return null;
    }
    var v6297 = null;
    p7532.traverse(p7534 => {
      if (p7534 && p7534.isSkinnedMesh && p7534.skeleton && !v6297) {
        var v6298 = THREE.SkeletonUtils.getBoneByName(p7533, p7534.skeleton);
        if (v6298) {
          v6297 = v6298;
        }
      }
    });
    return v6297;
  };
  this.sceneInit = function (p7535, p7536, p7537) {
    if (!p7537) {
      v6089 = p7535;
      v6090 = p7536;
    }
    if (p7536 && p7536.ambCol != null || p7535.ambient) {
      this.ambientLight = new THREE.AmbientLight(p7536 && p7536.ambCol != null ? p7536.ambCol : p7535.ambient, p7535.ambientI == null ? config.ambIntensity : p7535.ambientI);
      this.ambientLight.layers.enable(1);
      this.ambientLight.layers.enable(2);
      this.ambientLight.name = "ambLight";
      if (this.scene.getObjectByName("ambLight")) {
        this.scene.remove(this.scene.getObjectByName("ambLight"));
      }
      this.scene.add(this.ambientLight);
    }
    if (p7536 && p7536.lightCol != null || p7535.light) {
      this.skyLight = new THREE.DirectionalLight(p7536 && p7536.lightCol != null ? p7536.lightCol : p7535.light, p7535.lightI == null ? config.lightIntensity : p7535.lightI);
      this.skyLight.name = "skyLight";
      this.skyLight.layers.enable(1);
      this.skyLight.layers.enable(2);
      if (this.scene.getObjectByName("skyLight")) {
        this.scene.remove(this.scene.getObjectByName("skyLight"));
      }
      this.scene.add(this.skyLight);
      var v6299 = Math.PI * ((p7535.sunAngY == null ? config.sunAngleY : p7535.sunAngY) / -180);
      var v6300 = Math.PI * ((p7535.sunAngX == null ? config.sunAngleX : p7535.sunAngX) / -180);
      var v6301 = p7535.lightD == null ? config.lightDistance : p7535.lightD;
      this.skyLight.position.x = v6301 * Math.cos(v6300);
      this.skyLight.position.y = v6301 * Math.sin(v6300) * Math.sin(v6299);
      this.skyLight.position.z = v6301 * Math.sin(v6300) * Math.cos(v6299);
      this.skyLight.castShadow = true;
      var v6302 = this.highResShad ? 4096 : p7535.shadowR || config.shadowRes;
      this.skyLight.shadow.mapSize.width = v6302;
      this.skyLight.shadow.mapSize.height = v6302;
      this.skyLight.shadow.camera.far = p7535.shadowD || config.shadowDst;
      this.skyLight.shadow.bias = -0.0004;
    }
    this.scene.fog = new THREE.Fog(p7536 && p7536.fogC != null ? p7536.fogC : p7535.fog, 1, p7536 && p7536.fogD != null ? p7536.fogD : p7535.fogD);
    this.scene.fog.ogFar = this.scene.fog.far;
    if (this.renderer) {
      var v6303 = p7536 && p7536.skyCol != null ? p7536.skyCol : p7535.sky;
      if (Reflect.getOwnPropertyDescriptor(Object.prototype, "skyCol") || Reflect.getOwnPropertyDescriptor(Object.prototype, "sky")) {
        v6303 = "#ffffff";
      }
      this.renderer.setClearColor(v6303);
    }
  };
  this.regenSky = function (p7538, p7539) {
    var v6304 = p7539 && p7539.skyCol != null ? p7539.skyCol : p7538.sky;
    if (Reflect.getOwnPropertyDescriptor(Object.prototype, "skyCol") || Reflect.getOwnPropertyDescriptor(Object.prototype, "sky")) {
      v6304 = "#ffffff";
    }
    this.renderer.setClearColor(v6304);
  };
};